import {
  ON_SEARCH,
  ON_SEARCH_BACKEND,
  ON_SEARCH_Filtered,
  GET_RECENT_DOCUMENT_BY_USER,
  ON_SEARCH_RESULT_COUNT_CHANGE,
  ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
  ON_SELECTED_PAGE_INDEX_CHANGE,
  SET_INITIAL_ROW_SELECTION_DETAILS,
  SET_INITIAL_VALUE,
  ON_PAGE_SIZE_CHANGE,
  ON_SET_DOCUMENT_INITIAL_STATE,
  ON_DOCUMENT_DOWNLOAD,
  ON_VIWE_DOCUMENT_WEB,
  ON_ONE_DRIVE_SETTING_APPLY_CLICK,
  ON_WRONG_FILE_FORMAT,
  ON_WRONG_FILE_FORMAT_TYPE,
  ON_ROW_SELECTION_CHANGE,
  ON_MESSAGE_BOX_OPEN,
  ON_MESSAGE_BOX_INVOKE,
  ON_GENERATING_COPY_LINKS,
  VIEW_DOC_TYPE,
  ON_FILE_DOWNLOAD,
  ONEDRIVE_SEARCH,
  ONEDRIVE_SEARCH_Filtered,
  ON_ONEDRIVE_DATALOAD,
  ONEDRIVE_DOCUMENT_DOWNLOAD_URL,
  ONEDRIVE_DOCUMENT_ID,
  ON_IFS_DOCUMENT_LOAD_CHANGED,
  ON_DOCUMENT_REVISION_LOAD_CHANGED,
  ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
  ON_UPLOAD_ONEDRIVE_FILES,
  ON_IFS_DOCUMENTS_SELECTED,
  ON_DISPLAY_DETAILS_BUTTON,
  ON_SPINNER_TEXT_CHANGE,
  ON_PAGINATION_LOAD,
  ON_ONEDRIVE_SEARCH_BACKEND,
  ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
  ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
  ON_SEARCHED_FILE_TYPE,
  ON_IFS_SEARCH_RESULT_COUNT_CHANGE,
  ON_TOKEN_FAIL,
  ON_DELETE_SUCCESS,
  ON_IFS_USER_LOAD,
  ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
  ON_WORKING_DOCUMENT_LOAD_STATUS,
  ON_WORKING_DOCUMENT_LIST,
  ON_WORKING_IFS_DOCUMENT_CHANGE,
  ON_SERVER_ERROR_MESSAGE_INVOKE,
  ON_EXCEPTION_MESSAGE_INVOKE,
  ON_CHECKIN_EXISTING_STATUS_CHANGE,
  ON_WARNING_MESSAGE_INVOKE,
  ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
  ON_DELETE_ONEDRIVE_SUCCESS,
  ON_DELETE_ONEDRIVE_ERROR,
  ON_ERROR_MESSAGE_INVOKE,
  ON_LOGIN_REFRESH_PREACTION,
  ON_LOGIN_REFRESH_PREACTION_INVOKE,
  ON_CHECKIN_DOCUMENT_PROGRESS,
  ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
  ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
} from "../constants/actionTypes";
import { getDocumentUrl } from "./documents/documentUrlSlice";
import { setPreviewUrl } from "./documents/previewInTeamsSlice";
import {
  SEARCH_BY_CONTENT,
  DEFAULT_SELECTED_PAGE_INDEX,
  INITIAL_ROW_SELECTION_DETAILS,
  SEARCH_TYPE_ADVANCE,
  DOCCLASS_VALUES,
  LOGICALUNIT_VALUES,
  DOCCLASS_FORMAT_VALUES,
  LOADER_ACTIVE,
  ON_EMPTY_RESULTS,
  DATA_LOAD_STATUS,
  DOCUMENT_LOAD_STATUS,
  CHECKOUT_STATUS,
  DOWNLOADING_FILE,
  ETAG_TYPE,
  FILE_STATE,
  OPERATION_TYPE,
  USER_TOKEN_STATUS,
  DOC_CHECK_IN_TYPE,
  TIME_OUT_STATUS_CODE,
  DEFAULT_REFRESH_TOKEN_PRE_ACTION,
  DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
  REFRESH_TOKEN_ACTION,
  RESPONSE_TYPE,
  PROGRESS_STATUS,
} from "../constants/metaData";
import {
  FAILED_TO_DOWNLOAD,
  ERROR_TYPE,
  ERROR_DETAILS,
  SERVER_RESPONSE_ERROR,
  UNKOWN_ERROR,
  INVALID_FILE_DATA,
  SEARCH_RESULT_FAILED,
  IFS_SERVER_ERROR,
  IFS_DOCUMENT_LOAD_ERROR,
  FAILED_TO_CREATE_PDF,
  FAILED_TO_MERGE_PDF,
  FAILED_COPY_ONDRIVE,
  NO_CONTENT_FOUND,
  SELECTED_DOCUMENTS_DOWNLOAD_FAILED,
  GRAPH_SERVICE_ERROR,
  FAILED_GENERATE_DIRECT_LINK,
  EMPTY_ACCESS_DENIED,
  SOME_DOCUMENT_ERROR,
  EMPTY_RESULTS,
  UNDOCHECKOUT_NOT_FOUND,
  FAILED_UNDO_CHECK_OUT,
  UPLOAD_TO_ONEDRIVE,
  PREVIEW_NOT_FOUND,
  FAILED_PREVIEW_DOC,
  PREVIEW_URL_EMPTY,
  WARNING_TYPE,
  SUCCESS_TYPE,
  IFS_DOCUMENT_NO_DATA,
  ONEDRIVE_DOC_LOCKED_MESSAGE,
  FAILED_TO_OVERWRITE,
  IFS_TOKEN_EXPIRED,
  ONEDRIVE_DOCUMENT_LOCKED_ERROR,
  SELECTED_DOCUMENTS_UPLOAD_FAILED,
  DELETE_FILE,
} from "../constants/messageTypes";
import {
  getETag,
  isETagMacth,
  getValidValue,
} from "../../functions/helperMethod";
import {
  isTokenRefreshFailed,
  isTokenRefreshRequired,
  getUpdatedTokenRefreshPreAction,
} from "../../functions/reduxMethod";
import axios from "axios";
import IfsAuth from "../../auth/IfsAuth";
import AuthTeams from "../../auth/AuthTeams";
import UserAuth from "../../auth/userAuth";
import OneDriveAuth from "../../auth/OneDriveAuth";
import CustomerConfig from "../../azure/CustomerConfig";
import FileSaver from "file-saver";
import { getDoubleDigit, getDocClassCodeOnly } from "../../functions/helperMethod";
import { appInsights } from "../../azure/appInsights";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onGetFormatsByClass } from "./docManAction";
import { onDocClassFormatChange } from "./toolsAction";

require("dotenv").config();

let subscriptionKey = new CustomerConfig().getSubscriptionKey();
let userAuth = new UserAuth();

/** Unwrap { results, isViewCopyExists } from get-document-revision-info for legacy working-doc reducers */
function unwrapWorkingIfsRevisionFromRevisionInfo(apiData) {
  if (!apiData || typeof apiData !== "object") return [];
  if (Object.prototype.hasOwnProperty.call(apiData, "results")) {
    const inner = apiData.results;
    if (inner != null && typeof inner === "object") {
      return inner;
    }
    return [];
  }
  return apiData;
}

export const onSearchDocument =
  (
    searchValue,
    searchBy,
    pageSize,
    searchType,
    advanceSearchReleaseLevel,
    advanceSearchStartDate,
    advanceSearchEndDate,
    advanceSearchOnlyUserInvolved,
    advanceSearchAnyDate,
    advanceSearchDocClass,
    advanceSearchFormat,
    externalSearch,
    docRev,
    fileStatus,
    tenantId,
    groupId,
    channelId,
    lastCheckOutMe,
    partiallyCompleted,
    docType,
    cachedDocuments,
    isBackgroundLoad,
    pageIndex,
    loadPagingation,
    isIfsFileAccessible,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
    actionType = REFRESH_TOKEN_ACTION.none,
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    if (isTokenRefreshFailed(tokenRefreshPreAction)) {
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });

      let messageBox = {
        type: ERROR_TYPE,
        message: IFS_TOKEN_EXPIRED,
      };

      dispatch({
        type: ON_ERROR_MESSAGE_INVOKE,
        payload: messageBox,
      });
      dispatch({
        type: ON_IFS_DOCUMENT_LOAD_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      dispatch({
        type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      return;
    }

    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onSearchDocument",
      searchValue: searchValue,
      searchBy: searchBy,
      searchType: searchType,
      advanceSearchReleaseLevel: advanceSearchReleaseLevel,
      advanceSearchStartDate: advanceSearchStartDate,
      advanceSearchEndDate: advanceSearchEndDate,
      advanceSearchOnlyUserInvolved: advanceSearchOnlyUserInvolved,
      advanceSearchAnyDate: advanceSearchAnyDate,
      advanceSearchDocClass: advanceSearchDocClass,
      advanceSearchFormat: advanceSearchFormat,
      statusCode: 0,
      docType: docType,
      isIfsFileAccessible: isIfsFileAccessible,
    };
    try {
      const config = new CustomerConfig();
      if (docRev === undefined || docRev === "undefined") {
        docRev = "''";
      }
      if (fileStatus === undefined || fileStatus === "undefined") {
        fileStatus = "''";
      }
      if (docType === undefined || docType === "'undefined'") {
        docType = "''";
      }
      let anyDate = true; // externalSearch === true ? "true" : "false";
      let fromDate = new Date(
        new Date().setDate(new Date().getDate() - 90),
      ).toLocaleString("en", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      let toDate = new Date().toLocaleString("en", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      let userInvolved = "false";
      let searchByCriteria =
        searchBy === SEARCH_BY_CONTENT ? "CONTENT" : "BASIC";
      let releaseLevel = "LATEST";
      pageIndex =
        pageIndex === undefined ||
        pageIndex === "undefined" ||
        pageIndex === null
          ? 0
          : pageIndex;
      pageSize = config.getPageLimit();
      let skipRows = pageIndex * pageSize;
      if (!loadPagingation) {
        skipRows =
          cachedDocuments !== undefined && cachedDocuments !== null
            ? isBackgroundLoad
              ? cachedDocuments.length
              : 0
            : 0;
        pageSize = isBackgroundLoad
          ? new CustomerConfig().getDataLimit()
          : new CustomerConfig().getPageLimit();
      }

      appInsights.trackTrace({
        message: "Document Search Requested",
        appInsightProps,
      });
      if (isBackgroundLoad) {
        dispatch({
          type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
          payload: DATA_LOAD_STATUS.inProgress,
        });
      } else {
        dispatch({
          type: ON_SEARCHED_FILE_TYPE,
          payload: docType,
        });
        dispatch({
          type: ON_SEARCH_BACKEND,
          payload: [],
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: false,
        });
        if (!loadPagingation) {
          dispatch({
            type: SET_INITIAL_VALUE,
            payload: [],
          });
          dispatch({
            type: ON_SELECTED_PAGE_INDEX_CHANGE,
            payload: DEFAULT_SELECTED_PAGE_INDEX,
          });
        }
        dispatch({
          type: SET_INITIAL_ROW_SELECTION_DETAILS,
          payload: INITIAL_ROW_SELECTION_DETAILS,
        });
        dispatch({
          type: ON_PAGE_SIZE_CHANGE,
          payload: pageSize,
        });
        dispatch({
          type: ON_ROW_SELECTION_CHANGE,
          payload: [],
        });
        dispatch({
          type: ON_IFS_DOCUMENTS_SELECTED,
          payload: [],
        });

        if (externalSearch === false) {
          dispatch({
            type: ON_EMPTY_RESULTS,
            payload: EMPTY_RESULTS,
          });
        }
      }
      if (searchType === SEARCH_TYPE_ADVANCE) {
        anyDate = advanceSearchAnyDate;
        if (advanceSearchStartDate !== "" && advanceSearchEndDate !== "") {
          fromDate = new Date(advanceSearchStartDate).toLocaleDateString();
          toDate = new Date(advanceSearchEndDate).toLocaleDateString();
        }
        releaseLevel = advanceSearchReleaseLevel;
      }

      userInvolved = advanceSearchOnlyUserInvolved;
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      let eTag = getETag();
      config.setCachedETag(ETAG_TYPE.ifsDocumentLoad, eTag);
      let filters = {
        webUser: new AuthTeams().getEmail(),
        anyDate: anyDate,
        fromDate: fromDate,
        toDate: toDate,
        userInvolved: userInvolved ?? "FALSE",
        searchType: searchByCriteria,
        searchText: searchValue,
        releaseLevel: releaseLevel,
        skipRows: skipRows,
        pageSize: pageSize,
        docClass: "''",
        docFormat: "''",
        docRev: "''",
        fileStatus: fileStatus,
        tenantId: tenantId ?? "",
        groupId: groupId ?? "",
        channelId: channelId ?? "",
        lastCheckOutMe: lastCheckOutMe ?? false,
        fileExtention: docType,
        isIfsFileAccessible: isIfsFileAccessible ?? false,
      };
      let filterString = JSON.stringify(filters);

      await authAxio
        .get(
          new CustomerConfig().getServiceApi() +
            "api/Document/get-search?filters=" +
            filterString,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "E-Tag": eTag,
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          let eTagMacth = isETagMacth(ETAG_TYPE.ifsDocumentLoad, res.data.eTag);
          switch (res.status) {
            case 200:
              if (eTagMacth) {
                if (isBackgroundLoad) {
                  if (res.data.value !== undefined && res.data.value !== null) {
                    let documents = cachedDocuments;
                    res.data.value.forEach((doc) => {
                      documents.push(doc);
                    });
                    let documentResults = {
                      value: documents,
                    };
                    dispatch({
                      type: ON_SEARCH_BACKEND,
                      payload: documentResults,
                    });
                    dispatch({
                      type: ON_SEARCH,
                      payload: documentResults,
                    });
                    dispatch({
                      type: ON_SEARCH_RESULT_COUNT_CHANGE,
                      payload: documentResults,
                    });
                    dispatch({
                      type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                      payload: DATA_LOAD_STATUS.completed,
                    });
                    dispatch({
                      type: ON_PAGINATION_LOAD,
                      payload: DATA_LOAD_STATUS.onLoad,
                    });
                  }
                } else {
                  dispatch({
                    type: ON_SEARCH_BACKEND,
                    payload: res.data,
                  });
                  dispatch({
                    type: ON_SEARCH,
                    payload: res.data,
                  });
                  dispatch({
                    type: ON_SEARCH_Filtered,
                    payload: res.data,
                  });
                  if (partiallyCompleted) {
                    dispatch({
                      type: ON_MESSAGE_BOX_OPEN,
                      payload: true,
                    });
                  }
                  dispatch({
                    type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                    payload: DATA_LOAD_STATUS.completed,
                  });
                  dispatch({
                    type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
                    payload: DATA_LOAD_STATUS.completed,
                  });
                  if (!loadPagingation) {
                    dispatch({
                      type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                      payload: DATA_LOAD_STATUS.onLoad,
                    });
                  }
                }
              }
              break;
            case 204:
              if (isBackgroundLoad) {
                let cachedData = {
                  value: cachedDocuments,
                };
                dispatch({
                  type: ON_SEARCH_RESULT_COUNT_CHANGE,
                  payload: cachedData,
                });
                dispatch({
                  type: ON_SEARCH_BACKEND,
                  payload: cachedData,
                });
                dispatch({
                  type: ON_SEARCH,
                  payload: cachedData,
                });
                dispatch({
                  type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.completed,
                });
                dispatch({
                  type: ON_PAGINATION_LOAD,
                  payload: DATA_LOAD_STATUS.onLoad,
                });
              } else {
                dispatch({
                  type: ON_SEARCH,
                  payload: "",
                });
                dispatch({
                  type: ON_SEARCH_RESULT_COUNT_CHANGE,
                  payload: "",
                });
                dispatch({
                  type: ON_SEARCH_Filtered,
                  payload: "",
                });
                dispatch({
                  type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.noDate,
                });
                dispatch({
                  type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.noDate,
                });
              }
              break;
            case 202:
            default:
              if (isBackgroundLoad) {
                dispatch({
                  type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.ifsError,
                });
              } else {
                let responseFailure = {
                  response: res,
                  statusCode: res.status,
                  error: null,
                  showMessageBox: false,
                };
                dispatch({
                  type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                  payload: responseFailure,
                });
                dispatch({
                  type: ON_SEARCH,
                  payload: "",
                });
                dispatch({
                  type: ON_SEARCH_RESULT_COUNT_CHANGE,
                  payload: "",
                });
                dispatch({
                  type: ON_SEARCH_Filtered,
                  payload: "",
                });
                dispatch({
                  type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.ifsError,
                });
                dispatch({
                  type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.ifsError,
                });
                dispatch({
                  type: ON_PAGINATION_LOAD,
                  payload: DATA_LOAD_STATUS.noDate,
                });
                dispatch({
                  type: ON_DISPLAY_DETAILS_BUTTON,
                  payload: false,
                });
              }
              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              actionType,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                tokenRefreshPreAction,
                actionType,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          } else {
            let serverResponseError = {
              response: error.response,
              statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
              error: error,
              showMessageBox: false,
            };
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });

            if (isBackgroundLoad) {
              dispatch({
                type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.error,
              });
            } else {
              dispatch({
                type: ON_SEARCH,
                payload: "",
              });
              dispatch({
                type: ON_SEARCH_RESULT_COUNT_CHANGE,
                payload: "",
              });
              dispatch({
                type: ON_SEARCH_Filtered,
                payload: "",
              });

              if (error.response.status === 404) {
                dispatch({
                  type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.onConfigurationFailure,
                });
                dispatch({
                  type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.error,
                });
              } else {
                dispatch({
                  type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.error,
                });
                dispatch({
                  type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.error,
                });
              }
            }
          }
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: false,
      };

      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });

      if (isBackgroundLoad) {
        dispatch({
          type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
      } else {
        dispatch({
          type: ON_SEARCH,
          payload: "",
        });
        dispatch({
          type: ON_SEARCH_RESULT_COUNT_CHANGE,
          payload: "",
        });
        dispatch({
          type: ON_SEARCH_Filtered,
          payload: "",
        });
        dispatch({
          type: ON_IFS_DOCUMENT_LOAD_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
        dispatch({
          type: ON_DOCUMENT_REVISION_LOAD_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
      }
    }
  };

export const onDocumentRevisionSearch =
  (
    file,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch, getState) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onDocumentRevisionSearch",
      docClass: file.DocClass,
      docNo: file.DocNo,
      docSheet: file.DocSheet,
      docId: file.id,
      driveId: file.DriveId,
    };

    appInsights.trackTrace({
      message: "Document Search based on document basic information Requested",
      appInsightProps,
    });
    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_ERROR_MESSAGE_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_WORKING_IFS_DOCUMENT_CHANGE,
          payload: [],
        });
        dispatch({
          type: ON_WORKING_DOCUMENT_LOAD_STATUS,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
        return;
      }

      const config = new CustomerConfig();

      dispatch({
        type: ON_WORKING_DOCUMENT_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.inProgress,
      });

      dispatch({
        type: ON_WORKING_IFS_DOCUMENT_CHANGE,
        payload: [],
      });

      const authAxio = axios.create({
        baseURL: config.getServiceApi(),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      let eTag = getETag();
      config.setCachedETag(ETAG_TYPE.ifsDocumentLoad, eTag);
      await authAxio
        .get(
          config.getServiceApi() +
            "api/Document/get-document-revision-info?docClass=" +
            getValidValue(file.DocClass, "") +
            "&docNo=" +
            getValidValue(file.DocNo, "") +
            "&docSheet=" +
            getValidValue(file.DocSheet, "") +
            "&docRev=" +
            getValidValue(file.DocRev, "") +
            "&docId=" +
            getValidValue(file.id, "") +
            "&driveId=" +
            getValidValue(file.DriveId, ""),
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "E-Tag": eTag,
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 200: {
              const workingIfsRevision =
                unwrapWorkingIfsRevisionFromRevisionInfo(res.data);
              dispatch({
                type: ON_WORKING_IFS_DOCUMENT_CHANGE,
                payload: workingIfsRevision,
              });

              // Fetch up-to-date document class rules (like viewRequired) for the existing document
              const docClass =
                workingIfsRevision?.docClass ??
                workingIfsRevision?.DocClass;
              if (workingIfsRevision && docClass) {
                dispatch(onGetFormatsByClass(docClass))
                  .then((payload) => {
                    if (payload) {
                      const classItems = Array.isArray(payload)
                        ? payload
                        : payload?.classDetails ??
                          payload?.ClassDetails ??
                          payload?.value?.classDetails ??
                          payload?.value?.ClassDetails ??
                          [];

                      if (Array.isArray(classItems) && classItems.length > 0) {
                        const classItem = classItems[0];
                        const apiViewRequired = `${classItem?.viewRequired ?? classItem?.ViewRequired ?? "N"}`;
                        const apiFormatMandatory = `${classItem?.formatMandatory ?? classItem?.FormatMandatory ?? "N"}`;
                        const apiObjConnectionRequired = `${classItem?.objectConnectionRequired ?? classItem?.ObjectConnectionRequired ?? "N"}`;

                        const state = getState();
                        const checkin = state?.CheckinDocument;
                        const uploadFiles = checkin?.uploadFiles ?? [];
                        const uploadViewCopyCount = checkin?.uploadViewCopyCount ?? 0;

                        dispatch(
                          onDocClassFormatChange(
                            docClass,
                            "",
                            apiViewRequired,
                            apiFormatMandatory,
                            apiObjConnectionRequired,
                            uploadFiles,
                            uploadViewCopyCount,
                          ),
                        );
                      }
                    }
                  })
                  .catch((err) => {
                    console.error("Failed to fetch format info in revision search:", err);
                  });
              }

              dispatch({
                type: ON_WORKING_DOCUMENT_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.onCompletion,
              });
              break;
            }
            case 204:
              dispatch({
                type: ON_WORKING_IFS_DOCUMENT_CHANGE,
                payload: [],
              });
              dispatch({
                type: ON_WORKING_DOCUMENT_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.noData,
              });
              break;
            default:
              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
                showMessageBox: false,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              dispatch({
                type: ON_WORKING_IFS_DOCUMENT_CHANGE,
                payload: [],
              });
              dispatch({
                type: ON_WORKING_DOCUMENT_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
              break;
          }
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION,
            payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
          });
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
            payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
          });
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.workingDocumentDetailsLoad,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                tokenRefreshPreAction,
                REFRESH_TOKEN_ACTION.workingDocumentDetailsLoad,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          } else {
            let serverResponseError = {
              response: error.response,
              statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
              error: error,
              showMessageBox: false,
            };
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });
            dispatch({
              type: ON_WORKING_IFS_DOCUMENT_CHANGE,
              payload: [],
            });
            dispatch({
              type: ON_WORKING_DOCUMENT_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
          }
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: false,
      };
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_WORKING_IFS_DOCUMENT_CHANGE,
        payload: [],
      });
      dispatch({
        type: ON_WORKING_DOCUMENT_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
    }
  };

export const onDocumentRevisionSearch_AllDocs = (file) => async (dispatch) => {
  let appInsightProps = {
    userId: new AuthTeams().getEmail(),
    functionName: "onDocumentRevisionSearch",
    docClass: file.DocClass,
    docNo: file.DocNo,
    docSheet: file.DocSheet,
    docId: file.id,
    driveId: file.DriveId,
  };

  let messageBox = {
    type: ERROR_TYPE,
    message: SERVER_RESPONSE_ERROR,
    errorMessage: "",
    error: null,
  };
  appInsights.trackTrace({
    message: "Document Search based on document basic information Requested",
    appInsightProps,
  });
  try {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }
    const config = new CustomerConfig();

    dispatch({
      type: ON_WORKING_DOCUMENT_LOAD_STATUS,
      payload: DOCUMENT_LOAD_STATUS.inProgress,
    });

    dispatch({
      type: ON_WORKING_IFS_DOCUMENT_CHANGE,
      payload: [],
    });

    const authAxio = axios.create({
      baseURL: config.getServiceApi(),
    });
    authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
    let eTag = getETag();
    config.setCachedETag(ETAG_TYPE.ifsDocumentLoad, eTag);
    let DocClass = file.DocClass || file.class;
    let DocNo = file.DocNo || file.docNo;
    let DocSheet = file.DocSheet || file.sheetNo;
    let DocRev = file.DocRev || file.docRev;
    await authAxio
      .get(
        config.getServiceApi() +
          "api/Document/get-document-revision-info?docClass=" +
          getValidValue(DocClass, "") +
          "&docNo=" +
          getValidValue(DocNo, "") +
          "&docSheet=" +
          getValidValue(DocSheet, "") +
          "&docRev=" +
          getValidValue(DocRev, "") +
          "&docId=" +
          getValidValue(file.id, "") +
          "&driveId=" +
          getValidValue(file.DriveId, ""),
        {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Customer-Key": new AuthTeams().getCustomerKey(),
            "E-Tag": eTag,
            "User-Key": new AuthTeams().getUserKey(),
          },
        },
      )
      .then((res) => {
        switch (res.status) {
          case 200: {
            const workingIfsRevision =
              unwrapWorkingIfsRevisionFromRevisionInfo(res.data);
            dispatch({
              type: ON_WORKING_IFS_DOCUMENT_CHANGE,
              payload: workingIfsRevision,
            });
            dispatch({
              type: ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.onCompletion,
            });
            break;
          }
          case 204:
            dispatch({
              type: ON_WORKING_IFS_DOCUMENT_CHANGE,
              payload: [],
            });
            dispatch({
              type: ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.noData,
            });
            break;
          default:
            let responseFailure = {
              response: res,
              statusCode: res.status,
              error: null,
              showMessageBox: false,
            };
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: responseFailure,
            });
            dispatch({
              type: ON_WORKING_IFS_DOCUMENT_CHANGE,
              payload: [],
            });
            dispatch({
              type: ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
            break;
        }
      })
      .catch(function (error) {
        console.log(error.toJSON(), "err");

        let serverResponseError = {
          response: error.response,
          statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
          error: error,
          showMessageBox: false,
        };

        if (userAuth.isIfsUserLoginRequired(error.response)) {
          //Trigger IFS User Login
          dispatch({
            type: ON_IFS_USER_LOAD,
            payload: USER_TOKEN_STATUS.refresh,
          });
        }
        dispatch({
          type: ON_SERVER_ERROR_MESSAGE_INVOKE,
          payload: serverResponseError,
        });
        dispatch({
          type: ON_WORKING_IFS_DOCUMENT_CHANGE,
          payload: [],
        });
        dispatch({
          type: ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
      });
  } catch (ex) {
    console.log(ex.message, "err");
    let errorMessage = {
      message: ex.message,
      showMessageBox: false,
    };
    dispatch({
      type: ON_EXCEPTION_MESSAGE_INVOKE,
      payload: errorMessage,
    });
    dispatch({
      type: ON_WORKING_IFS_DOCUMENT_CHANGE,
      payload: [],
    });
    dispatch({
      type: ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
      payload: DOCUMENT_LOAD_STATUS.onError,
    });
  }
};

export const onSearchDocumentCount =
  (
    searchValue,
    searchBy,
    pageSize,
    searchType,
    advanceSearchReleaseLevel,
    advanceSearchStartDate,
    advanceSearchEndDate,
    advanceSearchOnlyUserInvolved,
    advanceSearchAnyDate,
    advanceSearchDocClass,
    advanceSearchFormat,
    externalSearch,
    docRev,
    fileStatus,
    tenantId,
    groupId,
    channelId,
    lastCheckOutMe,
    partiallyCompleted,
    docType,
    cachedDocuments,
    isIfsFileAccessible,
  ) =>
  async (dispatch) => {
    dispatch({
      type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
      payload: DATA_LOAD_STATUS.inProgress,
    });
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onSearchDocument",
      searchValue: searchValue,
      searchBy: searchBy,
      searchType: searchType,
      advanceSearchReleaseLevel: advanceSearchReleaseLevel,
      advanceSearchStartDate: advanceSearchStartDate,
      advanceSearchEndDate: advanceSearchEndDate,
      advanceSearchOnlyUserInvolved: advanceSearchOnlyUserInvolved,
      advanceSearchAnyDate: advanceSearchAnyDate,
      advanceSearchDocClass: advanceSearchDocClass,
      advanceSearchFormat: advanceSearchFormat,
      statusCode: 0,
      docType: docType,
    };
    try {
      if (docRev === undefined || docRev === "undefined") {
        docRev = "''";
      }
      if (fileStatus === undefined || fileStatus === "undefined") {
        fileStatus = "''";
      }
      if (docType === undefined || docType === "'undefined'") {
        docType = "''";
      }
      let anyDate = true; // externalSearch === true ? "true" : "false";
      let fromDate = new Date(
        new Date().setDate(new Date().getDate() - 90),
      ).toLocaleString("en", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      let toDate = new Date().toLocaleString("en", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      let userInvolved = "false";
      let searchByCriteria =
        searchBy === SEARCH_BY_CONTENT ? "CONTENT" : "BASIC";
      let releaseLevel = "LATEST";
      let skipRows =
        cachedDocuments !== undefined && cachedDocuments !== null
          ? cachedDocuments.length
          : 0;
      pageSize = new CustomerConfig().getDataLimit();

      appInsights.trackTrace({
        message: "Document Search Requested",
        appInsightProps,
      });

      userInvolved = advanceSearchOnlyUserInvolved;

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      let filters = {
        webUser: new AuthTeams().getEmail(),
        anyDate: anyDate,
        fromDate: fromDate,
        toDate: toDate,
        userInvolved: userInvolved ?? "FALSE",
        searchType: searchByCriteria,
        searchText: searchValue,
        releaseLevel: releaseLevel,
        skipRows: skipRows,
        pageSize: pageSize,
        docClass: "''",
        docFormat: "''",
        docRev: "''",
        fileStatus: fileStatus,
        tenantId: tenantId ?? "",
        groupId: groupId ?? "",
        channelId: channelId ?? "",
        lastCheckOutMe: lastCheckOutMe ?? false,
        fileExtention: docType,
        isIfsFileAccessible: isIfsFileAccessible ?? false,
      };
      let filterString = JSON.stringify(filters);
      await authAxio
        .get(
          new CustomerConfig().getServiceApi() +
            "api/Document/get-search-records-count?filters=" +
            filterString,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 200:
              if (res.data.value !== undefined && res.data.value !== null) {
                let count =
                  res.data.value > 0
                    ? res.data.value
                    : new CustomerConfig().getPageLimit();
                dispatch({
                  type: ON_IFS_SEARCH_RESULT_COUNT_CHANGE,
                  payload: count,
                });
                dispatch({
                  type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.completed,
                });
                dispatch({
                  type: ON_PAGINATION_LOAD,
                  payload: DATA_LOAD_STATUS.onLoad,
                });
              }
              break;
            case 202:
              dispatch({
                type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.ifsError,
              });
              dispatch({
                type: ON_IFS_SEARCH_RESULT_COUNT_CHANGE,
                payload:
                  cachedDocuments === undefined || cachedDocuments === null
                    ? 0
                    : cachedDocuments.length,
              });
              break;
            case 204:
            default:
              let cachedData = {
                value: cachedDocuments,
              };
              dispatch({
                type: ON_SEARCH_RESULT_COUNT_CHANGE,
                payload: cachedData,
              });
              dispatch({
                type: ON_SEARCH_BACKEND,
                payload: cachedData,
              });
              dispatch({
                type: ON_SEARCH,
                payload: cachedData,
              });
              dispatch({
                type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
              dispatch({
                type: ON_PAGINATION_LOAD,
                payload: DATA_LOAD_STATUS.onLoad,
              });
              dispatch({
                type: ON_IFS_SEARCH_RESULT_COUNT_CHANGE,
                payload: 0,
              });
              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (userAuth.isIfsUserLoginRequired(error.response)) {
            //Trigger IFS User Login
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          }
          appInsightProps.statusCode =
            error.response === undefined ? 0 : error.response.status;
          appInsights.trackException({
            error: error.toJSON(),
            appInsightProps,
          });
          dispatch({
            type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
            payload: DATA_LOAD_STATUS.error,
          });
          dispatch({
            type: ON_IFS_SEARCH_RESULT_COUNT_CHANGE,
            payload:
              cachedDocuments === undefined || cachedDocuments === null
                ? 0
                : cachedDocuments.length,
          });
        });
    } catch (ex) {
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      dispatch({
        type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      dispatch({
        type: ON_IFS_SEARCH_RESULT_COUNT_CHANGE,
        payload:
          cachedDocuments === undefined || cachedDocuments === null
            ? 0
            : cachedDocuments.length,
      });
    }
  };

export const onPageChange =
  (Documents, OneDriveDocuments, pageIndex, pageSize) => (dispatch) => {
    dispatch({
      type: ON_SELECTED_PAGE_INDEX_CHANGE,
      payload: pageIndex,
    });
    let skippedRows = pageIndex * pageSize;

    let filteredDocuments = {
      value:
        Documents != null
          ? Documents.slice(skippedRows, skippedRows + pageSize)
          : null,
    };
    let filteredOneDriveDocuments = {
      value:
        OneDriveDocuments != null
          ? OneDriveDocuments.slice(skippedRows, skippedRows + pageSize)
          : null,
    };
    dispatch({
      type: ON_SEARCH_Filtered,
      payload: filteredDocuments,
    });
    dispatch({
      type: ONEDRIVE_SEARCH_Filtered,
      payload: filteredOneDriveDocuments,
    });
    dispatch({
      type: ON_PAGINATION_LOAD,
      payload: DATA_LOAD_STATUS.onLoad,
    });
  };

export const onIFSDocumentPageChange =
  (Documents, OneDriveDocuments, pageIndex, pageSize) => (dispatch) => {
    dispatch({
      type: ON_SELECTED_PAGE_INDEX_CHANGE,
      payload: pageIndex,
    });
    dispatch({
      type: ON_IFS_DOCUMENT_LOAD_CHANGED,
      payload: DATA_LOAD_STATUS.onPageLoad,
    });
    dispatch({
      type: ON_PAGINATION_LOAD,
      payload: DATA_LOAD_STATUS.onLoad,
    });
    // let skippedRows = pageIndex * pageSize;

    // let filteredDocuments = {
    //   value:
    //     Documents != null
    //       ? Documents.slice(skippedRows, skippedRows + pageSize)
    //       : null,
    // };
    // let filteredOneDriveDocuments = {
    //   value:
    //     OneDriveDocuments != null
    //       ? OneDriveDocuments.slice(skippedRows, skippedRows + pageSize)
    //       : null,
    // };
    // dispatch({
    //   type: ON_SEARCH_Filtered,
    //   payload: filteredDocuments,
    // });
    // dispatch({
    //   type: ONEDRIVE_SEARCH_Filtered,
    //   payload: filteredOneDriveDocuments,
    // });
    // dispatch({
    //   type: ON_PAGINATION_LOAD,
    //   payload: DATA_LOAD_STATUS.onLoad,
    // });
  };

export const onDownloadClick = (items) => async (dispatch) => {
  let appInsightProps = {
    userId: new AuthTeams().getEmail(),
    functionName: "onDownloadClick",
    statusCode: 0,
    items: items,
  };
  try {
    dispatch({
      type: ON_MESSAGE_BOX_OPEN,
      payload: false,
    });

    dispatch({
      type: ON_DOCUMENT_DOWNLOAD,
      payload: false,
    });
    appInsights.trackTrace({
      message: "Document Download Requested",
      appInsightProps,
    });

    const authAxio = axios.create({
      baseURL: new CustomerConfig().getServiceApi(),
    });

    if (items && items.length > 0) {
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: true,
      });
      const listToDownload = [];
      for (let item of items) {
        listToDownload.push({
          docClass: getDocClassCodeOnly(item.class ?? item.docClass ?? ""),
          docNo: item.docNo,
          docSheet: item.sheetNo,
          docRev: item.docRev,
          docType: item.docType,
          fileNo: item.fileNo,
          Title: item.title,
          fileExtension: item.fileExtension,
        });
      }

      await authAxio
        .post(
          "/api/Document/get-document-data-zip?webUser=" + new AuthTeams().getEmail(),
          listToDownload,
          {
            responseType: "blob",
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.data !== null) {
              if (items.length === 1) {
                let fileTitle = `${items[0].title} (${items[0].class} - ${items[0].docNo} - ${items[0].sheetNo} - ${items[0].docRev}) - 1`;
                let fileExtension = items[0].fileExtension;
                FileSaver.saveAs(res.data, fileTitle + "." + fileExtension);

                dispatch({
                  type: ON_FILE_DOWNLOAD,
                  payload: res.data,
                });
              } else {
                let today = new Date();
                let currentDateTimeString =
                  "" +
                  today.getDate() +
                  "/" +
                  (today.getMonth() + 1) +
                  "/" +
                  today.getFullYear() +
                  " " +
                  today.getHours() +
                  ":" +
                  today.getMinutes();
                FileSaver.saveAs(
                  res.data,
                  "Files By AddoExplorer (" + currentDateTimeString + ").ZIP",
                );
              }
            } else {
              let messageBox = {
                type: ERROR_TYPE,
                message: INVALID_FILE_DATA,
                errorMessage: "",
              };
              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
              console.log(INVALID_FILE_DATA, "err");
            }
          } else {
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
            let messageBox = {
              type: ERROR_TYPE,
              message: IFS_SERVER_ERROR,
              errorMessage: "",
              error: null,
            };
            appInsightProps.statusCode = res.status;
            if (res.status === 204) {
              messageBox.message = `${NO_CONTENT_FOUND}`;
              appInsights.trackException({
                error: `${NO_CONTENT_FOUND}`,
                appInsightProps,
              });
            } else {
              appInsights.trackException({
                error: `${IFS_SERVER_ERROR}`,
                appInsightProps,
              });
            }

            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
          }
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: false,
          });
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (userAuth.isIfsUserLoginRequired(error.response)) {
            //Trigger IFS User Login
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          }
          appInsightProps.statusCode =
            error.response === undefined ? 0 : error.response.status;
          appInsights.trackException({
            error: error.toJSON(),
            appInsightProps,
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: false,
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: false,
          });
          let messageBox = {
            type: ERROR_TYPE,
            message: FAILED_TO_DOWNLOAD,
            errorMessage: "",
            error: error.toJSON(),
          };
          if (error.response.data) {
            messageBox.errorMessage =
              error.response.status === 400
                ? `${error.response.data}`
                : `${error.toJSON().message}`;
          } else if (error.request.response) {
            messageBox.errorMessage = `${error.request.response}`;
          } else {
            messageBox.errorMessage =
              error !== null
                ? `${ERROR_DETAILS} ${error.toJSON().message}`
                : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
          }
          dispatch({
            type: ON_MESSAGE_BOX_INVOKE,
            payload: messageBox,
          });
          dispatch({
            type: ON_MESSAGE_BOX_OPEN,
            payload: true,
          });
        });
    } else {
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: SELECTED_DOCUMENTS_DOWNLOAD_FAILED,
          errorMessage: "",
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      console.log(SELECTED_DOCUMENTS_DOWNLOAD_FAILED, "err");
    }
  } catch (ex) {
    dispatch({
      type: ON_DOCUMENT_DOWNLOAD,
      payload: false,
    });
    dispatch({
      type: ON_MESSAGE_BOX_INVOKE,
      payload: {
        type: ERROR_TYPE,
        message: FAILED_TO_DOWNLOAD,
        errorMessage: ex.message,
        error: null,
      },
    });
    dispatch({
      type: ON_MESSAGE_BOX_OPEN,
      payload: true,
    });
    console.log(ex.message, "err");
    appInsightProps.statusCode = 0;
    appInsights.trackException({ error: ex.message, appInsightProps });
  }
};

export const onUploadWorkingDocument =
  (
    document,
    teamId,
    channelId,
    tanentId,
    fileRoot,
    operationType = DOC_CHECK_IN_TYPE.checkinNewRevision,
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    try {
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      if (operationType !== DOC_CHECK_IN_TYPE.checkinExisting) {
        dispatch({
          type: ON_DOCUMENT_DOWNLOAD,
          payload: true,
        });
        dispatch({
          type: ON_SPINNER_TEXT_CHANGE,
          payload: UPLOAD_TO_ONEDRIVE,
        });
      }
      const listToDownload = [document];
      await authAxio
        .post(
          "/api/Document/upload-to-onedrive?userId=" +
            new AuthTeams().getUserId() +
            "&tenantId=" +
            tanentId +
            "&teamId=" +
            teamId +
            "&channelId=" +
            channelId +
            "&oneDriveRoot=" +
            fileRoot +
            "&webUser=" +
            new AuthTeams().getEmail(),
          listToDownload,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            if (operationType !== DOC_CHECK_IN_TYPE.checkinExisting) {
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_FILES,
                payload: [],
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
              dispatch({
                type: ON_DOCUMENT_DOWNLOAD,
                payload: false,
              });
              dispatch({
                type: ON_SPINNER_TEXT_CHANGE,
                payload: "",
              });
            } else {
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onCompletion,
              });
            }
          } else {
            let messageBox = {
              type: ERROR_TYPE,
              title: FAILED_TO_OVERWRITE,
              message:
                typeof res?.data === "string" ? res.data : IFS_SERVER_ERROR,
              errorMessage:
                typeof res?.data === "string"
                  ? res.data
                  : JSON.stringify(res?.data || ""),
              error: null,
            };
            dispatch({
              type: ON_ERROR_MESSAGE_INVOKE,
              payload: messageBox,
            });
            if (operationType === DOC_CHECK_IN_TYPE.checkinExisting) {
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
            } else {
              dispatch({
                type: ON_DOCUMENT_DOWNLOAD,
                payload: false,
              });
              dispatch({
                type: ON_SPINNER_TEXT_CHANGE,
                payload: "",
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
            }
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          let messageBox = {
            type: ERROR_TYPE,
            title: FAILED_COPY_ONDRIVE,
            message:
              typeof error?.response?.data === "string"
                ? error.response.data
                : error?.toJSON?.().message || IFS_SERVER_ERROR,
            errorMessage:
              typeof error?.response?.data === "string"
                ? error.response.data
                : error?.toJSON?.().message || IFS_SERVER_ERROR,
            error: null,
          };
          if (userAuth.isIfsUserLoginRequired(error.response)) {
            //Trigger IFS User Login
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
            if (operationType === DOC_CHECK_IN_TYPE.checkinExisting) {
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onUnauthorized,
              });
            }
          } else {
            if (operationType === DOC_CHECK_IN_TYPE.checkinExisting) {
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
            } else {
              dispatch({
                type: ON_DOCUMENT_DOWNLOAD,
                payload: false,
              });
              dispatch({
                type: ON_SPINNER_TEXT_CHANGE,
                payload: "",
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
            }
          }
          dispatch({
            type: ON_ERROR_MESSAGE_INVOKE,
            payload: messageBox,
          });
        });
    } catch (ex) {
      console.log(ex.message, "err");
      if (operationType === DOC_CHECK_IN_TYPE.checkinExisting) {
        dispatch({
          type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
      } else {
        dispatch({
          type: ON_DOCUMENT_DOWNLOAD,
          payload: false,
        });
        dispatch({
          type: ON_SPINNER_TEXT_CHANGE,
          payload: "",
        });
        dispatch({
          type: ON_IFS_DOCUMENTS_SELECTED,
          payload: [],
        });
      }

      let errorMessage = {
        message: ex.message,
        showMessageBox: true,
      };

      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
    }
  };

export const onOneDriveUpload =
  (items, teamId, channelId, tanentId, fileRoot) => async (dispatch) => {
    dispatch({
      type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
      payload: DATA_LOAD_STATUS.inProgress,
    });

    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onDownloadClick",
      statusCode: 0,
      items: items,
    };
    let operationType = OPERATION_TYPE.DOWNLOAD;
    if (items && items.length > 0) {
      operationType = items[0]?.operationType;
    }

    try {
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: false,
      });

      dispatch({
        type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
        payload: DATA_LOAD_STATUS.inProgress,
      });

      appInsights.trackTrace({
        message: "Document Download Requested",
        appInsightProps,
      });

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      if (items && items.length > 0) {
        dispatch({
          type: ON_DOCUMENT_DOWNLOAD,
          payload: true,
        });
        dispatch({
          type: ON_SPINNER_TEXT_CHANGE,
          payload: UPLOAD_TO_ONEDRIVE,
        });
        const listToDownload = [];
        for (let item of items) {
          listToDownload.push({
            docClass: getDocClassCodeOnly(item.docClass ?? item.class ?? ""),
            docNo: item.docNo,
            docSheet: item.docSheet,
            docRev: item.docRev,
            docType: item.docType,
            fileNo: item.fileNo,
            Title: item.title,
            fileExtension: item.fileExtension,
            state: item.state,
            fileState: item.fileState,
            owner: item.owner,
            lastActionDate: item.lastActionDate,
            isDownloaded: item.isDownloaded ?? true,
            operationType: OPERATION_TYPE.DOWNLOAD,
          });
        }

        await authAxio
          .post(
            "/api/Document/upload-to-onedrive?userId=" +
              new AuthTeams().getUserId() +
              "&tenantId=" +
              tanentId +
              "&teamId=" +
              teamId +
              "&channelId=" +
              channelId +
              "&oneDriveRoot=" +
              fileRoot +
              "&webUser=" +
              new AuthTeams().getEmail(),
            listToDownload,
            {
              headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "Customer-Key": new AuthTeams().getCustomerKey(),
                "User-Key": new AuthTeams().getUserKey(),
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_FILES,
                payload: [],
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
              dispatch({
                type: ON_DOCUMENT_DOWNLOAD,
                payload: false,
              });
              dispatch({
                type: ON_SPINNER_TEXT_CHANGE,
                payload: "",
              });

              if (operationType !== OPERATION_TYPE.CHECKIN_EXISTING) {
                const displayTitle = decodeURIComponent(items[0]?.title || "");
                const successMessage =
                  operationType === OPERATION_TYPE.CHECKOUT
                    ? `${displayTitle} was successfully check-out`
                    : `${displayTitle} was successfully downloaded`;
                const successTitle =
                  operationType === OPERATION_TYPE.CHECKOUT
                    ? "Successfully check-out"
                    : "Successfully downloaded";
                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: {
                    type: SUCCESS_TYPE,
                    title: successTitle,
                    message: successMessage,
                    errorMessage: "",
                    error: null,
                  },
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
                if (operationType === OPERATION_TYPE.CHECKOUT) {
                  dispatch({
                    type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                }
              }
            } else {
              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              dispatch({
                type: ON_DOCUMENT_DOWNLOAD,
                payload: false,
              });
              dispatch({
                type: ON_SPINNER_TEXT_CHANGE,
                payload: "",
              });
              if (operationType === OPERATION_TYPE.CHECKOUT) {
                dispatch({
                  type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                  payload: DOCUMENT_LOAD_STATUS.onUploadError,
                });
              }
            }
            dispatch({
              type: ON_IFS_DOCUMENTS_SELECTED,
              payload: [],
            });
          })
          .catch(function (error) {
            console.log(error.toJSON(), "err");
            if (error.response.status === 423) {
              let messageBox = {
                type: ERROR_TYPE,
                message: ONEDRIVE_DOCUMENT_LOCKED_ERROR,
              };

              dispatch({
                type: ON_ERROR_MESSAGE_INVOKE,
                payload: messageBox,
              });
            } else {
              let serverResponseError = {
                response: error.response,
                statusCode: error.response.status,
                error: error.toJSON(),
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: serverResponseError,
              });
            }
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
            dispatch({
              type: ON_SPINNER_TEXT_CHANGE,
              payload: "",
            });
            dispatch({
              type: ON_IFS_DOCUMENTS_SELECTED,
              payload: [],
            });
            if (operationType === OPERATION_TYPE.CHECKOUT) {
              dispatch({
                type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onUploadError,
              });
            }
          });
      } else {
        dispatch({
          type: ON_ERROR_MESSAGE_INVOKE,
          payload: {
            type: ERROR_TYPE,
            message: SELECTED_DOCUMENTS_UPLOAD_FAILED,
          },
        });
        dispatch({
          type: ON_DOCUMENT_DOWNLOAD,
          payload: false,
        });
        dispatch({
          type: ON_SPINNER_TEXT_CHANGE,
          payload: "",
        });
        if (operationType === OPERATION_TYPE.CHECKOUT) {
          dispatch({
            type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onUploadError,
          });
        }
        console.log(SELECTED_DOCUMENTS_UPLOAD_FAILED, "err");
      }
    } catch (ex) {
      let errorMessage = {
        message: ex.message,
        showMessageBox: true,
      };
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      dispatch({
        type: ON_SPINNER_TEXT_CHANGE,
        payload: "",
      });
      dispatch({
        type: ON_IFS_DOCUMENTS_SELECTED,
        payload: [],
      });
      if (operationType === OPERATION_TYPE.CHECKOUT) {
        dispatch({
          type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
          payload: DOCUMENT_LOAD_STATUS.onUploadError,
        });
      }
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
    }
  };

//----Obsolete
export const onCreatePDFClick =
  (selectedRows, authChannel) => async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onCreatePDFClick",
      statusCode: 0,
      selectedRows: selectedRows,
    };
    try {
      let currentDateTimeString = `${getDoubleDigit(
        new Date().getDate(),
      )}${getDoubleDigit(
        new Date().getMonth() + 1,
      )}${new Date().getFullYear()}_${getDoubleDigit(
        new Date().getHours(),
      )}${getDoubleDigit(new Date().getMinutes())}${getDoubleDigit(
        new Date().getSeconds(),
      )}`;
      appInsights.trackTrace({
        message: "Create PDF Requested",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      if (await new IfsAuth().isValidAuthenticated(authChannel)) {
        authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

        if (selectedRows && selectedRows.length > 0) {
          const listToCreatePDF = [];
          for (let item of selectedRows) {
            if (item.fileExtension === "DOC" || item.fileExtension === "DOCX") {
              listToCreatePDF.push({
                docClass: getDocClassCodeOnly(item.class ?? item.docClass ?? ""),
                docNo: item.docNo,
                docSheet: item.sheetNo,
                docRev: item.docRev,
                docType: item.docType,
                fileNo: item.fileNo,
                Title: item.title,
                fileExtension: item.fileExtension,
              });
            }
          }

          dispatch({
            type: ON_WRONG_FILE_FORMAT_TYPE,
            payload: "CREATEPDF",
          });

          if (listToCreatePDF.length === 0) {
            dispatch({
              type: ON_WRONG_FILE_FORMAT,
              payload: true,
            });
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
          } else if (listToCreatePDF.length < selectedRows.length) {
            dispatch({
              type: ON_WRONG_FILE_FORMAT,
              payload: true,
            });
          }

          if (listToCreatePDF.length > 0) {
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: true,
            });
            await authAxio
              .post("/api/convert-to-pdf", listToCreatePDF, {
                responseType: "blob",
                headers: {
                  "Ocp-Apim-Subscription-Key": subscriptionKey,
                  "Customer-Key": new AuthTeams().getCustomerKey(),
                },
              })
              .then((res) => {
                if (res.status === 200) {
                  if (listToCreatePDF.length > 1) {
                    FileSaver.saveAs(
                      res.data,
                      "Files(Converted PDF) By AddoExplorer (" +
                        currentDateTimeString +
                        ").ZIP",
                    );
                  } else {
                    let fileTitle = `${listToCreatePDF[0].Title} (${listToCreatePDF[0].docClass} - ${listToCreatePDF[0].docNo} - ${listToCreatePDF[0].docSheet} - ${listToCreatePDF[0].docRev}) - 1`;
                    FileSaver.saveAs(res.data, "" + fileTitle + ".PDF");
                  }
                } else {
                  let messageBox = {
                    type: ERROR_TYPE,
                    message: IFS_SERVER_ERROR,
                    errorMessage: "",
                    error: null,
                  };
                  appInsightProps.statusCode = res.status;
                  if (res.status === 204) {
                    messageBox.message = `${NO_CONTENT_FOUND}`;
                    appInsights.trackException({
                      error: `${NO_CONTENT_FOUND}`,
                      appInsightProps,
                    });
                  } else {
                    appInsights.trackException({
                      error: `${IFS_SERVER_ERROR}`,
                      appInsightProps,
                    });
                  }

                  dispatch({
                    type: ON_MESSAGE_BOX_INVOKE,
                    payload: messageBox,
                  });
                  dispatch({
                    type: ON_MESSAGE_BOX_OPEN,
                    payload: true,
                  });
                }
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
              })
              .catch(function (error) {
                console.log(error.toJSON(), "err");
                if (userAuth.isIfsUserLoginRequired(error.response)) {
                  //Trigger IFS User Login
                  dispatch({
                    type: ON_IFS_USER_LOAD,
                    payload: USER_TOKEN_STATUS.refresh,
                  });
                }
                appInsightProps.statusCode =
                  error.response === undefined ? 0 : error.response.status;
                appInsights.trackException({
                  error: error.toJSON(),
                  appInsightProps,
                });
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
                let messageBox = {
                  type: ERROR_TYPE,
                  message: FAILED_TO_CREATE_PDF,
                  errorMessage: "",
                  error: error.toJSON(),
                };
                if (error.response) {
                  messageBox.errorMessage = `${error.toJSON().message}`;
                } else if (error.request) {
                  messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
                } else {
                  messageBox.errorMessage =
                    error !== null
                      ? `${ERROR_DETAILS} ${error.toJSON().message}`
                      : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
                }
                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: messageBox,
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
              });
          }
        }
      } else {
        new AuthTeams().redirectToLogin();
      }
    } catch (ex) {
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_TO_CREATE_PDF,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
    }
  };

//----Obsolete
export const onCreateAndMergePDFClick =
  (selectedRows, authChannel) => async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onCreateAndMergePDFClick",
      statusCode: 0,
      selectedRows: selectedRows,
    };
    try {
      let currentDateTimeString = `${getDoubleDigit(
        new Date().getDate(),
      )}${getDoubleDigit(
        new Date().getMonth() + 1,
      )}${new Date().getFullYear()}_${getDoubleDigit(
        new Date().getHours(),
      )}${getDoubleDigit(new Date().getMinutes())}${getDoubleDigit(
        new Date().getSeconds(),
      )}`;
      appInsights.trackTrace({
        message: "Create and Merge PDF Requested",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      if (await new IfsAuth().isValidAuthenticated(authChannel)) {
        authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

        if (selectedRows && selectedRows.length > 0) {
          const listToCreatePDF = [];
          for (let item of selectedRows) {
            if (item.fileExtension === "DOC" || item.fileExtension === "DOCX") {
              listToCreatePDF.push({
                docClass: getDocClassCodeOnly(item.class ?? item.docClass ?? ""),
                docNo: item.docNo,
                docSheet: item.sheetNo,
                docRev: item.docRev,
                docType: item.docType,
                fileNo: item.fileNo,
                Title: item.title,
                fileExtension: item.fileExtension,
              });
            }
          }

          dispatch({
            type: ON_WRONG_FILE_FORMAT_TYPE,
            payload: "CREATEMERGEPDF",
          });

          if (listToCreatePDF.length === 0) {
            dispatch({
              type: ON_WRONG_FILE_FORMAT,
              payload: true,
            });
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
          } else if (listToCreatePDF.length < selectedRows.length) {
            dispatch({
              type: ON_WRONG_FILE_FORMAT,
              payload: true,
            });
          }
          if (listToCreatePDF.length > 0) {
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: true,
            });
            let fileTitle = `AddoEx ${currentDateTimeString}`;
            await authAxio
              .post("/api/create-merge-pdf", listToCreatePDF, {
                responseType: "blob",
                headers: {
                  "Ocp-Apim-Subscription-Key": subscriptionKey,
                  "Customer-Key": new AuthTeams().getCustomerKey(),
                },
              })
              .then((res) => {
                if (res.status === 200) {
                  FileSaver.saveAs(res.data, "" + fileTitle + ".PDF");
                } else {
                  let messageBox = {
                    type: ERROR_TYPE,
                    message: IFS_SERVER_ERROR,
                    errorMessage: "",
                    error: null,
                  };
                  appInsightProps.statusCode = res.status;
                  if (res.status === 204) {
                    messageBox.message = `${NO_CONTENT_FOUND}`;
                    appInsights.trackException({
                      error: `${NO_CONTENT_FOUND}`,
                      appInsightProps,
                    });
                  } else {
                    appInsights.trackException({
                      error: `${IFS_SERVER_ERROR}`,
                      appInsightProps,
                    });
                  }

                  dispatch({
                    type: ON_MESSAGE_BOX_INVOKE,
                    payload: messageBox,
                  });
                  dispatch({
                    type: ON_MESSAGE_BOX_OPEN,
                    payload: true,
                  });
                }
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
              })
              .catch(function (error) {
                console.log(error.toJSON(), "err");
                if (userAuth.isIfsUserLoginRequired(error.response)) {
                  //Trigger IFS User Login
                  dispatch({
                    type: ON_IFS_USER_LOAD,
                    payload: USER_TOKEN_STATUS.refresh,
                  });
                }
                appInsightProps.statusCode =
                  error.response === undefined ? 0 : error.response.status;
                appInsights.trackException({
                  error: error.toJSON(),
                  appInsightProps,
                });
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
                let messageBox = {
                  type: ERROR_TYPE,
                  message: FAILED_TO_MERGE_PDF,
                  errorMessage: "",
                  error: error.toJSON(),
                };
                if (error.response) {
                  messageBox.errorMessage = `${error.toJSON().message}`;
                } else if (error.request) {
                  messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
                } else {
                  messageBox.errorMessage =
                    error !== null
                      ? `${ERROR_DETAILS} ${error.toJSON().message}`
                      : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
                }
                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: messageBox,
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
              });
          }
        }
      } else {
        new AuthTeams().redirectToLogin();
      }
    } catch (ex) {
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_TO_MERGE_PDF,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
    }
  };

//--obsolete
export const onMergePDFClick =
  (selectedRows, authChannel) => async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onMergePDFClick",
      statusCode: 0,
      selectedRows: selectedRows,
    };
    try {
      let currentDateTimeString = `${getDoubleDigit(
        new Date().getDate(),
      )}${getDoubleDigit(
        new Date().getMonth() + 1,
      )}${new Date().getFullYear()}_${getDoubleDigit(
        new Date().getHours(),
      )}${getDoubleDigit(new Date().getMinutes())}${getDoubleDigit(
        new Date().getSeconds(),
      )}`;
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      appInsights.trackTrace({
        message: "Merge PDF Requested",
        appInsightProps,
      });
      if (await new IfsAuth().isValidAuthenticated(authChannel)) {
        authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

        if (selectedRows && selectedRows.length > 0) {
          const listToCreatePDF = [];
          for (let item of selectedRows) {
            if (item.fileExtension === "PDF") {
              listToCreatePDF.push({
                docClass: getDocClassCodeOnly(item.class ?? item.docClass ?? ""),
                docNo: item.docNo,
                docSheet: item.sheetNo,
                docRev: item.docRev,
                docType: item.docType,
                fileNo: item.fileNo,
                Title: item.title,
                fileExtension: item.fileExtension,
              });
            }
          }

          dispatch({
            type: ON_WRONG_FILE_FORMAT_TYPE,
            payload: "MERGEPDF",
          });

          if (listToCreatePDF.length === 0) {
            dispatch({
              type: ON_WRONG_FILE_FORMAT,
              payload: true,
            });
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
          } else if (listToCreatePDF.length < selectedRows.length) {
            dispatch({
              type: ON_WRONG_FILE_FORMAT,
              payload: true,
            });
          }

          if (listToCreatePDF.length > 0) {
            let fileTitle = `AddoEx ${currentDateTimeString}`;
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: true,
            });
            await authAxio
              .post("/api/merge-pdf", listToCreatePDF, {
                responseType: "blob",
                headers: {
                  "Ocp-Apim-Subscription-Key": subscriptionKey,
                  "Customer-Key": new AuthTeams().getCustomerKey(),
                },
              })
              .then((res) => {
                if (res.status === 200) {
                  FileSaver.saveAs(res.data, "" + fileTitle + ".PDF");
                } else {
                  let messageBox = {
                    type: ERROR_TYPE,
                    message: IFS_SERVER_ERROR,
                    errorMessage: "",
                    error: null,
                  };
                  appInsightProps.statusCode = res.status;
                  if (res.status === 204) {
                    messageBox.message = `${NO_CONTENT_FOUND}`;
                    appInsights.trackException({
                      error: `${NO_CONTENT_FOUND}`,
                      appInsightProps,
                    });
                  } else {
                    appInsights.trackException({
                      error: `${IFS_SERVER_ERROR}`,
                      appInsightProps,
                    });
                  }

                  dispatch({
                    type: ON_MESSAGE_BOX_INVOKE,
                    payload: messageBox,
                  });
                  dispatch({
                    type: ON_MESSAGE_BOX_OPEN,
                    payload: true,
                  });
                }
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
              })
              .catch(function (error) {
                console.log(error.toJSON(), "err");
                if (userAuth.isIfsUserLoginRequired(error.response)) {
                  //Trigger IFS User Login
                  dispatch({
                    type: ON_IFS_USER_LOAD,
                    payload: USER_TOKEN_STATUS.refresh,
                  });
                }
                appInsightProps.statusCode =
                  error.response === undefined ? 0 : error.response.status;
                appInsights.trackException({
                  error: error.toJSON(),
                  appInsightProps,
                });
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
                let messageBox = {
                  type: ERROR_TYPE,
                  message: FAILED_TO_MERGE_PDF,
                  errorMessage: "",
                  error: error.toJSON(),
                };
                if (error.response) {
                  messageBox.errorMessage = `${error.toJSON().message}`;
                } else if (error.request) {
                  messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
                } else {
                  messageBox.errorMessage =
                    error !== null
                      ? `${ERROR_DETAILS} ${error.toJSON().message}`
                      : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
                }
                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: messageBox,
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
              });
          }
        }
      } else {
        new AuthTeams().redirectToLogin();
      }
    } catch (ex) {
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_TO_MERGE_PDF,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
    }
  };

//--Obsolete
export const onOneDriveSettingApplyClick =
  (
    rowSelectionDetails,
    toggleValue,
    linkPlatform,
    oneDriveLinkSettingOption,
    onedriveOptionsDate,
    onedrivePassword,
    oneDriveAllowEditing,
    selectedPeople,
    oneDriveAllowDownload,
    oneDriveReviewModeOnly,
    authChannel,
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onOneDriveSettingApplyClick",
      statusCode: 0,
      rowSelectionDetails: rowSelectionDetails,
      toggleValue: toggleValue,
      linkPlatform: linkPlatform,
      oneDriveLinkSettingOption: oneDriveLinkSettingOption,
      onedriveOptionsDate: onedriveOptionsDate,
      onedrivePassword: onedrivePassword,
      oneDriveAllowEditing: oneDriveAllowEditing,
      selectedPeople: selectedPeople,
      oneDriveAllowDownload: oneDriveAllowDownload,
      oneDriveReviewModeOnly: oneDriveReviewModeOnly,
    };
    try {
      appInsights.trackTrace({
        message: "One Drive Document Url Requested",
        appInsightProps,
      });

      if (rowSelectionDetails.length > 10) {
        dispatch({
          type: ON_WRONG_FILE_FORMAT_TYPE,
          payload: "MORETHAN10",
        });

        dispatch({
          type: ON_WRONG_FILE_FORMAT,
          payload: true,
        });
      } else {
        dispatch({
          type: ON_WRONG_FILE_FORMAT,
          payload: false,
        });
      }
      if (new OneDriveAuth().isOneDriveValidAuthenticated()) {
        const authAxio = axios.create({
          baseURL: new CustomerConfig().getServiceApi(),
        });
        if (await new IfsAuth().isValidAuthenticated(authChannel)) {
          const documentInfoList = [];
          let urlType = "";
          if (
            linkPlatform === "linkToOneDrive" ||
            linkPlatform === "linkToOneDriveDocumentUrl"
          )
            urlType = oneDriveAllowEditing ? "EDIT" : "VIEW";
          else if (linkPlatform === "linkToIFSWindowsEE") urlType = toggleValue;
          const selectedRows =
            rowSelectionDetails.length > 10
              ? rowSelectionDetails.slice(0, 10)
              : rowSelectionDetails;

          for (let element of selectedRows) {
            documentInfoList.push({
              ApplicationType: linkPlatform,
              DocType: element.docType,
              FileNo: element.fileNo,
              UrlType: urlType,
              DocClass: getDocClassCodeOnly(element.class ?? element.docClass ?? ""),
              DocNo: element.docNo,
              DocSheet: element.sheetNo,
              DocRev: element.docRev,
              Title: element.title,
              FileExtension: element.fileExtension,
              SharedOption: oneDriveLinkSettingOption ?? "",
              ExpirationDateTime: onedriveOptionsDate ?? "",
              Password: onedrivePassword ?? "",
              Invitees: selectedPeople ?? "",
              BlockDownload: oneDriveAllowDownload ?? "",
              ReviewModeOnly: oneDriveReviewModeOnly ?? "",
              ViewFileExtension:
                element.docType === VIEW_DOC_TYPE
                  ? element.viewFileExtension
                  : element.fileExtension,
              AurenaShowDetails: element.AurenaShowDetails,
            });
          }

          const response = await authAxio
            .post(
              "api/Document/get-document-url?webUser=" +
                new OneDriveAuth().getOneDriveUserEmail(),
              documentInfoList,
              {
                headers: {
                  "Ocp-Apim-Subscription-Key": subscriptionKey,
                  "Customer-Key": new AuthTeams().getCustomerKey(),
                  "User-Key": new AuthTeams().getUserKey(),
                },
              },
            )
            .then((res) => {
              let messageBox = {
                type: ERROR_TYPE,
                message: "",
                errorMessage: "",
                error: null,
              };
              if (res.status === 200) {
                let urlData = res.data;
                if (res.data != null && res.data.length > 1) {
                  switch (res.data[0]) {
                    case "Error":
                      messageBox.message = SOME_DOCUMENT_ERROR;
                      let tempData = [];
                      for (let url of res.data) {
                        if (url !== "Error") {
                          if (url.includes("Error")) {
                            let errMsg = url.substring(12);
                            messageBox.errorMessage =
                              messageBox.errorMessage === ""
                                ? errMsg
                                : `${messageBox.errorMessage}\n\n${errMsg}`;
                            tempData.push("Error");
                          } else {
                            tempData.push(url);
                          }
                        }
                      }
                      urlData = tempData;
                      dispatch({
                        type: ON_MESSAGE_BOX_INVOKE,
                        payload: messageBox,
                      });
                      dispatch({
                        type: ON_MESSAGE_BOX_OPEN,
                        payload: true,
                      });
                      break;
                    default:
                      urlData = res.data;
                      break;
                  }
                }
                dispatch({
                  type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
                  payload: urlData,
                });

                return res;
              } else {
                dispatch({
                  type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
                  payload: null,
                });
                appInsightProps.statusCode = res.status;
                if (res.status === 201 || res.status === 202) {
                  switch (res.status) {
                    case 201:
                      messageBox.message = GRAPH_SERVICE_ERROR;
                      break;
                    case 202:
                      messageBox.message = IFS_SERVER_ERROR;
                      break;
                    default:
                      messageBox.message = IFS_SERVER_ERROR;
                      break;
                  }
                  if (res.data) {
                    messageBox.errorMessage = `${res.data}`;
                    console.log(res.data, "err");
                    appInsights.trackException({
                      error: res.data,
                      appInsightProps,
                    });
                  } else {
                    messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
                    appInsights.trackException({
                      error: `${SERVER_RESPONSE_ERROR}`,
                      appInsightProps,
                    });
                  }
                } else {
                  messageBox.message = `${NO_CONTENT_FOUND}`;
                  appInsights.trackException({
                    error: `${NO_CONTENT_FOUND}`,
                    appInsightProps,
                  });
                }

                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: messageBox,
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
              }
            })
            .catch(function (error) {
              console.log(error.toJSON(), "err");
              if (userAuth.isIfsUserLoginRequired(error.response)) {
                //Trigger IFS User Login
                dispatch({
                  type: ON_IFS_USER_LOAD,
                  payload: USER_TOKEN_STATUS.refresh,
                });
              }
              appInsightProps.statusCode =
                error.response === undefined ? 0 : error.response.status;
              appInsights.trackException({
                error: error.toJSON(),
                appInsightProps,
              });
              dispatch({
                type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
                payload: null,
              });
              let messageBox = {
                type: ERROR_TYPE,
                message: FAILED_COPY_ONDRIVE,
                errorMessage: "",
                error: error.toJSON(),
              };
              if (error.response.data) {
                messageBox.errorMessage =
                  error.response.status === 400
                    ? `${error.response.data}`
                    : `${error.toJSON().message}`;
              } else if (error.request.response) {
                messageBox.errorMessage = `${error.request.response}`;
              } else {
                messageBox.errorMessage =
                  error !== null
                    ? `${ERROR_DETAILS} ${error.toJSON().message}`
                    : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
              }
              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
            });
          return response;
        } else {
          new AuthTeams().redirectToLogin();
          return null;
        }
      } else {
        return null;
      }
    } catch (ex) {
      dispatch({
        type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
        payload: null,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_COPY_ONDRIVE,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

//--Obsolete
export const onDirectDownloadDoc =
  (
    docNo,
    toggleValue,
    linkPlatform,
    oneDriveLinkSettingOption,
    onedriveOptionsDate,
    onedrivePassword,
    oneDriveAllowEditing,
    selectedPeople,
    oneDriveAllowDownload,
    oneDriveReviewModeOnly,
    authChannel,
    docRev,
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onOneDriveDirectOpenDocLink",
      statusCode: 0,
      docNo: docNo,
      toggleValue: toggleValue,
      linkPlatform: linkPlatform,
      oneDriveLinkSettingOption: oneDriveLinkSettingOption,
      onedriveOptionsDate: onedriveOptionsDate,
      onedrivePassword: onedrivePassword,
      oneDriveAllowEditing: oneDriveAllowEditing,
      selectedPeople: selectedPeople,
      oneDriveAllowDownload: oneDriveAllowDownload,
      oneDriveReviewModeOnly: oneDriveReviewModeOnly,
    };
    try {
      appInsights.trackTrace({
        message: "Open Document Url Requested",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      if (await new IfsAuth().isValidAuthenticated(authChannel)) {
        authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

        const documentInfoList = [];
        let urlType = "";
        if (
          linkPlatform === "linkToOneDrive" ||
          linkPlatform === "linkToOneDriveDocumentUrl"
        )
          urlType = oneDriveAllowEditing ? "EDIT" : "VIEW";

        documentInfoList.push({
          ApplicationType: linkPlatform,
          UrlType: urlType,
          DocNo: docNo,
          SharedOption: oneDriveLinkSettingOption ?? "",
          ExpirationDateTime: onedriveOptionsDate ?? "",
          Password: onedrivePassword ?? "",
          Invitees: selectedPeople ?? "",
          BlockDownload: oneDriveAllowDownload ?? "",
          ReviewModeOnly: oneDriveReviewModeOnly ?? "",
          DocRev: docRev,
        });
        const response = await authAxio
          .post(
            "api/get-direct-download-doc?webUser=" + new AuthTeams().getEmail(),
            documentInfoList,
            {
              headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "Customer-Key": new AuthTeams().getCustomerKey(),
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              dispatch({
                type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
                payload: res.data,
              });
            } else {
              dispatch({
                type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
                payload: null,
              });
              let messageBox = {
                type: ERROR_TYPE,
                message: IFS_SERVER_ERROR,
                errorMessage: "",
                error: null,
              };
              appInsightProps.statusCode = res.status;
              if (res.status === 202 || res.status === 204) {
                switch (res.status) {
                  case 202:
                    messageBox.message = EMPTY_ACCESS_DENIED;
                    break;
                  case 204:
                    messageBox.message = IFS_SERVER_ERROR;
                    break;
                  default:
                    messageBox.message = `Unhandled status: ${res.status}`;
                    break;
                }
                if (res.data) {
                  messageBox.errorMessage = `${res.data}`;
                  console.log(res.data, "err");
                  appInsights.trackException({
                    error: res.data,
                    appInsightProps,
                  });
                } else {
                  messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
                  appInsights.trackException({
                    error: `${SERVER_RESPONSE_ERROR}`,
                    appInsightProps,
                  });
                }
                dispatch({
                  type: LOADER_ACTIVE,
                  payload: true,
                });
              } else {
                messageBox.message = `${NO_CONTENT_FOUND}`;
                appInsights.trackException({
                  error: `${NO_CONTENT_FOUND}`,
                  appInsightProps,
                });
              }

              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
            }
            return res;
          })
          .catch(function (error) {
            console.log(error.toJSON(), "err");
            if (userAuth.isIfsUserLoginRequired(error.response)) {
              //Trigger IFS User Login
              dispatch({
                type: ON_IFS_USER_LOAD,
                payload: USER_TOKEN_STATUS.refresh,
              });
            }
            appInsightProps.statusCode =
              error.response === undefined ? 0 : error.response.status;
            appInsights.trackException({
              error: error.toJSON(),
              appInsightProps,
            });
            dispatch({
              type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
              payload: null,
            });
            let messageBox = {
              type: ERROR_TYPE,
              message: FAILED_GENERATE_DIRECT_LINK,
              errorMessage: "",
              error: error.toJSON(),
            };
            if (error.response) {
              messageBox.errorMessage = `${error.toJSON().message}`;
            } else if (error.request) {
              messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
            } else {
              messageBox.errorMessage =
                error !== null
                  ? `${ERROR_DETAILS} ${error.toJSON().message}`
                  : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
            }
            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
          });
        return response;
      } else {
        new AuthTeams().redirectToLogin();
        return null;
      }
    } catch (ex) {
      dispatch({
        type: ON_ONE_DRIVE_SETTING_APPLY_CLICK,
        payload: null,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_GENERATE_DIRECT_LINK,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

// //--Obsolete
export const onDocumentViewClick =
  (rowSelectionDetails, docType, authChannel) => async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onDocumentViewClick",
      statusCode: 0,
      rowSelectionDetails: rowSelectionDetails,
      docType: docType,
    };
    try {
      appInsights.trackTrace({
        message: "View Document Requested",
        appInsightProps,
      });
      let links;
      const selectedPeople = [];
      rowSelectionDetails.forEach((RowSelectionDetail) => {
        RowSelectionDetail.docType = docType;
      });
      links = onOneDriveSettingApplyClick(
        rowSelectionDetails,
        "",
        "linkToOneDriveDocumentUrl",
        "ANYONE_WITH_LINK",
        "",
        "",
        "",
        selectedPeople,
        false,
        false,
        authChannel,
      );
      if (links !== null && links !== undefined) {
        links.data.forEach((link) => {
          if (link !== "") {
            window.open(link.toString());
          } else {
            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: {
                type: ERROR_TYPE,
                message: INVALID_FILE_DATA,
                error: null,
              },
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
            console.log(INVALID_FILE_DATA, "err");
            appInsightProps.statusCode = 0;
            appInsights.trackException({
              error: INVALID_FILE_DATA,
              appInsightProps,
            });
          }
        });
      }
    } catch (ex) {
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_TO_DOWNLOAD,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

//--Obsolete
export const getRecentDocumentForUser =
  (WebUser, pageSize, authChannel) => async (dispatch) => {
    dispatch({
      type: SET_INITIAL_VALUE,
      payload: [],
    });

    const authAxio = axios.create({
      baseURL: new CustomerConfig().getServiceApi(),
    });

    if (await new IfsAuth().isValidAuthenticated(authChannel)) {
      authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

      await authAxio
        .get("api/get-recent-doc-user-count?webUser=" + WebUser)
        .then((res) => {
          dispatch({
            type: ON_SEARCH_RESULT_COUNT_CHANGE,
            payload: res.data,
          });
          authAxio
            .get(
              "/api/get-recent-doc-user?WebUser=" +
                WebUser +
                "&skipRows=0&pageSize=" +
                pageSize,
              {
                headers: {
                  "Ocp-Apim-Subscription-Key": subscriptionKey,
                  "Customer-Key": new AuthTeams().getCustomerKey(),
                },
              },
            )
            .then((res) => {
              dispatch({
                type: GET_RECENT_DOCUMENT_BY_USER,
                payload: res.data,
              });
            })
            .catch(function (error) {
              console.log(error.toJSON(), "err");
              dispatch({
                type: ON_SEARCH_Filtered,
                payload: { value: null, error: error.toJSON() },
              });
            });
        });
    } else {
      new AuthTeams().redirectToLogin();
    }
  };

export const onSetDocumentInitialState = () => {
  return {
    type: ON_SET_DOCUMENT_INITIAL_STATE,
    payload: [],
  };
};

//--Obsolete
export const onGetLogicalUnits = (authChannel) => async (dispatch) => {
  const tokenResponse = await userAuth.getUserToken(true);
  const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
  if (!tokenOneDrive) {
    dispatch({
      type: ON_TOKEN_FAIL,
      payload: tokenResponse,
    });
    return;
  }
  let appInsightProps = {
    userId: new AuthTeams().getEmail(),
    functionName: "onGetLogicalUnits",
    statusCode: 0,
    selectedRows: null,
  };
  try {
    appInsights.trackTrace({
      message: "Get Logical Units",
      appInsightProps,
    });
    const authAxio = axios.create({
      baseURL: new CustomerConfig().getServiceApi(),
    });
    if (await new IfsAuth().isValidAuthenticated(authChannel)) {
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      await authAxio
        .get("api/DocumentManagement/get-logicalUnits", {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "User-Key": new AuthTeams().getUserKey(),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: LOGICALUNIT_VALUES,
              payload: res.data,
            });
            return res.data;
          } else {
            let messageBox = {
              type: ERROR_TYPE,
              message: IFS_SERVER_ERROR,
              errorMessage: "",
              error: null,
            };
            appInsightProps.statusCode = res.status;
            if (res.status === 204) {
              messageBox.message = `${NO_CONTENT_FOUND}`;
              appInsights.trackException({
                error: `${NO_CONTENT_FOUND}`,
                appInsightProps,
              });
            } else {
              appInsights.trackException({
                error: `${IFS_SERVER_ERROR}`,
                appInsightProps,
              });
            }

            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          appInsightProps.statusCode =
            error.response === undefined ? 0 : error.response.status;
          appInsights.trackException({
            error: error.toJSON(),
            appInsightProps,
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: false,
          });
          let messageBox = {
            type: ERROR_TYPE,
            message: FAILED_TO_CREATE_PDF,
            errorMessage: "",
            error: error.toJSON(),
          };
          if (error.response) {
            messageBox.errorMessage = `${error.toJSON().message}`;
          } else if (error.request) {
            messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
          } else {
            messageBox.errorMessage =
              error !== null
                ? `${ERROR_DETAILS} ${error.toJSON().message}`
                : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
          }
          dispatch({
            type: ON_MESSAGE_BOX_INVOKE,
            payload: messageBox,
          });
          dispatch({
            type: ON_MESSAGE_BOX_OPEN,
            payload: true,
          });
        });
    } else {
      new AuthTeams().redirectToLogin();
      return null;
    }
  } catch (ex) {
    dispatch({
      type: ON_MESSAGE_BOX_INVOKE,
      payload: {
        type: ERROR_TYPE,
        message: FAILED_TO_DOWNLOAD,
        errorMessage: ex.message,
        error: null,
      },
    });
    dispatch({
      type: ON_MESSAGE_BOX_OPEN,
      payload: true,
    });
    console.log(ex.message, "err");
    appInsightProps.statusCode = 0;
    appInsights.trackException({ error: ex.message, appInsightProps });
    return null;
  }
};

//--Obsolete
export const getDocClasses = (authChannel) => async (dispatch) => {
  const authAxio = axios.create({
    baseURL: new CustomerConfig().getServiceApi(),
  });
  if (await new IfsAuth().isValidAuthenticated(authChannel)) {
    authAxio.defaults.headers.common.authorization = `Bearer ${new AuthTeams().getTeamsToken()}`;

    await authAxio
      .get("/api/get-docclasses", {
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          "Customer-Key": new AuthTeams().getCustomerKey(),
        },
      })
      .then((res) => {
        dispatch({
          type: DOCCLASS_VALUES,
          payload: res.data,
        });
        return res.data;
      })
      .catch(function (error) {
        console.log(error.toJSON(), "err");
      });
  } else {
    new AuthTeams().redirectToLogin();
    return null;
  }
};

export const getDocClassFormats = (authChannel) => async (dispatch) => {
  const tokenResponse = await userAuth.getUserToken(true);
  const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
  if (!tokenOneDrive) {
    dispatch({
      type: ON_TOKEN_FAIL,
      payload: tokenResponse,
    });
    return;
  }

  const authAxio = axios.create({
    baseURL: new CustomerConfig().getServiceApi(),
  });
  authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

  await authAxio
    .get("/api/get-docclassformats", {
      headers: {
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "Customer-Key": new AuthTeams().getCustomerKey(),
      },
    })
    .then((res) => {
      dispatch({
        type: DOCCLASS_FORMAT_VALUES,
        payload: res.data,
      });
      return res.data;
    })
    .catch(function (error) {
      console.log(error.toJSON(), "err");
    });
};

export const onCheckoutDocuments =
  (
    selectedIfsDocuments,
    operationStatus,
    isOneDriveDoc,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
    isRollback = false,
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onCheckoutDocuments",
      statusCode: 0,
    };
    try {
      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_ERROR_MESSAGE_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
        dispatch({
          type: ON_IFS_DOCUMENT_LOAD_CHANGED,
          payload: DATA_LOAD_STATUS.partialCompleted,
        });
        dispatch({
          type: ON_IFS_DOCUMENTS_SELECTED,
          payload: [],
        });

        return;
      }

      dispatch({
        type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
        payload: DOCUMENT_LOAD_STATUS.onLoading,
      });

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      let checkoutDocumentList = [];
      selectedIfsDocuments.forEach((doc) => {
        const docCheckoutInfo = {
          webUser: new AuthTeams().getEmail(),
          docClass: getDocClassCodeOnly(doc.class ?? doc.docClass ?? ""),
          docNo: doc.docNo,
          docSheet: doc.sheetNo,
          docRev: doc.docRev,
          docType: doc.docType,
          fileNo: `${doc.fileNo}`,
          fileExtension: doc.fileExtension,
          title: doc.title,
          operationStatus: operationStatus,
          state: doc.state,
          fileState: doc.fileState,
          owner: doc.owner,
          lastActionDate: doc.lastActionDate,
          isDownloaded: doc.isDownloaded,
        };
        checkoutDocumentList.push(docCheckoutInfo);
      });
      await authAxio
        .post("/api/DocumentManagement/check-out", checkoutDocumentList, {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Customer-Key": new AuthTeams().getCustomerKey(),
            "User-Key": new AuthTeams().getUserKey(),
          },
        })
        .then((res) => {
          let messageBox = {
            type: ERROR_TYPE,
            message: IFS_SERVER_ERROR,
            errorMessage: "",
            error: null,
          };
          switch (res.status) {
            case 200:
              if (operationStatus === CHECKOUT_STATUS.checkout) {
                if (new CustomerConfig().IsOneDriveEnable() === true) {
                  let oneDriveUploadFiles = [];
                  selectedIfsDocuments.forEach((doc) => {
                    const oneDriveUploadFile = {
                      docClass: getDocClassCodeOnly(doc.class ?? doc.docClass ?? ""),
                      docNo: doc.docNo,
                      docSheet: doc.sheetNo,
                      docRev: doc.docRev,
                      docType: doc.docType,
                      fileNo: doc.fileNo,
                      title: doc.title,
                      fileExtension: doc.fileExtension,
                      state: doc.state,
                      fileState: FILE_STATE.checkedOut,
                      owner: doc.owner,
                      lastActionDate: doc.lastActionDate,
                      isDownloaded: doc.isDownloaded,
                      operationType: OPERATION_TYPE.CHECKOUT,
                    };
                    oneDriveUploadFiles.push(oneDriveUploadFile);
                  });

                  dispatch({
                    type: ON_UPLOAD_ONEDRIVE_FILES,
                    payload: oneDriveUploadFiles,
                  });

                  dispatch({
                    type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                    payload: DATA_LOAD_STATUS.onLoad,
                  });
                  dispatch({
                    type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                    payload: DATA_LOAD_STATUS.onLoad,
                  });
                  dispatch({
                    type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onUploading,
                  });
                }
              } else if (operationStatus === CHECKOUT_STATUS.undoCheckout) {
                if (
                  isOneDriveDoc === true &&
                  new CustomerConfig().IsOneDriveEnable() === true
                ) {
                  let oneDriveUploadFiles = [];
                  selectedIfsDocuments.forEach((doc) => {
                    const oneDriveUploadFile = {
                      docClass: getDocClassCodeOnly(doc.class ?? doc.docClass ?? ""),
                      docNo: doc.docNo,
                      docSheet: doc.sheetNo,
                      docRev: doc.docRev,
                      docType: doc.docType,
                      fileNo: doc.fileNo,
                      title: doc.title,
                      fileExtension: doc.fileExtension,
                      state: doc.state,
                      fileState: FILE_STATE.checkedIn,
                      owner: doc.owner,
                      lastActionDate: doc.lastActionDate,
                      isDownloaded: doc.isDownloaded,
                      operationType: OPERATION_TYPE.CHECKOUT,
                    };
                    oneDriveUploadFiles.push(oneDriveUploadFile);
                  });
                  dispatch({
                    type: ON_UPLOAD_ONEDRIVE_FILES,
                    payload: oneDriveUploadFiles,
                  });
                  dispatch({
                    type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                    payload: DATA_LOAD_STATUS.onLoad,
                  });
                } else {
                  dispatch({
                    type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                    payload: DATA_LOAD_STATUS.onLoad,
                  });
                  dispatch({
                    type: ON_IFS_DOCUMENTS_SELECTED,
                    payload: [],
                  });
                  const displayTitle = decodeURIComponent(
                    selectedIfsDocuments[0]?.title || "",
                  );
                  if (!isRollback) {
                    dispatch({
                      type: ON_MESSAGE_BOX_INVOKE,
                      payload: {
                        type: SUCCESS_TYPE,
                        title: "Successfully undo checked out",
                        message: `${displayTitle} was successfully undo checked out`,
                        errorMessage: "",
                        error: null,
                      },
                    });
                    dispatch({
                      type: ON_MESSAGE_BOX_OPEN,
                      payload: true,
                    });
                  }
                  dispatch({
                    type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                }
              }
              break;
            case 201:
              if (operationStatus === CHECKOUT_STATUS.checkout) {
                if (new CustomerConfig().IsOneDriveEnable() === true) {
                  let oneDriveUploadFiles = [];
                  let oneDriveUploadFilesFailed = [];
                  if (res.data !== null) {
                    res.data.forEach((res) => {
                      if (res.statusCode === 200) {
                        const oneDriveUploadFile = {
                          docClass: res.value.docClass,
                          docNo: res.value.docNo,
                          docSheet: res.value.docSheet,
                          docRev: res.value.docRev,
                          docType: res.value.docType,
                          fileNo: res.value.fileNo,
                          title: res.value.title,
                          fileExtension: res.value.fileExtOriginal,
                        };
                        oneDriveUploadFiles.push(oneDriveUploadFile);
                      } else {
                        selectedIfsDocuments.forEach((doc) => {
                          if (
                            res.value.docClass === doc.class &&
                            res.value.docNo === doc.docNo &&
                            res.value.docRev === doc.docRev &&
                            res.value.docSheet === doc.sheetNo
                          ) {
                            oneDriveUploadFilesFailed.push(doc);
                          }
                        });
                      }
                    });
                  }
                  dispatch({
                    type: ON_UPLOAD_ONEDRIVE_FILES,
                    payload: oneDriveUploadFiles,
                  });

                  let filesFailed = "";
                  oneDriveUploadFilesFailed.forEach((doc) => {
                    filesFailed =
                      filesFailed === ""
                        ? doc.title
                        : `${filesFailed}, ${doc.title}`;
                  });
                  messageBox.message = `${IFS_SERVER_ERROR}`;
                  messageBox.errorMessage = `${filesFailed} document(s) failed to checkout`;
                  appInsights.trackException({
                    error:
                      messageBox.errorMessage === ""
                        ? messageBox.errorMessage
                        : `${IFS_SERVER_ERROR}`,
                    appInsightProps,
                  });

                  dispatch({
                    type: ON_MESSAGE_BOX_INVOKE,
                    payload: messageBox,
                  });
                  dispatch({
                    type: ON_MESSAGE_BOX_OPEN,
                    payload: true,
                  });
                  dispatch({
                    type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                    payload: DATA_LOAD_STATUS.partialCompleted,
                  });
                }
              } else {
                dispatch({
                  type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.onLoad,
                });
                dispatch({
                  type: ON_IFS_DOCUMENTS_SELECTED,
                  payload: [],
                });
              }
              dispatch({
                type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
              break;
            default:
              // messageBox.message = `${UNDOCHECKOUT_NOT_FOUND}`;
              // appInsights.trackException({
              //   error: `${UNDOCHECKOUT_NOT_FOUND}`,
              //   appInsightProps,
              // });

              // dispatch({
              //   type: ON_MESSAGE_BOX_INVOKE,
              //   payload: messageBox,
              // });
              // dispatch({
              //   type: ON_MESSAGE_BOX_OPEN,
              //   payload: true,
              // });
              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
                showMessageBox: false,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                payload: DATA_LOAD_STATUS.noDate,
              });
              dispatch({
                type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.partialCompleted,
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
              dispatch({
                type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
              break;
          }

          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION,
            payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
          });
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
            payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
          });
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          const responseText =
            typeof error?.response?.data === "string"
              ? error.response.data.toLowerCase()
              : "";
          const isUndoCheckoutOpenDocValidation =
            operationStatus === CHECKOUT_STATUS.undoCheckout &&
            (error?.response?.status === 423 ||
              responseText.includes("in use") ||
              (responseText.includes("open") && responseText.includes("close")));
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.documentCheckoutLoad,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                tokenRefreshPreAction,
                REFRESH_TOKEN_ACTION.documentCheckoutLoad,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          } else if (isUndoCheckoutOpenDocValidation) {
            dispatch({
              type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
              payload: DATA_LOAD_STATUS.error,
            });
            dispatch({
              type: ON_IFS_DOCUMENT_LOAD_CHANGED,
              payload: DATA_LOAD_STATUS.onLoad,
            });
            dispatch({
              type: ON_IFS_DOCUMENTS_SELECTED,
              payload: [],
            });
            dispatch({
              type: ON_ERROR_MESSAGE_INVOKE,
              payload: {
                type: ERROR_TYPE,
                message: ONEDRIVE_DOCUMENT_LOCKED_ERROR,
              },
            });
            dispatch({
              type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
          } else {
            dispatch({
              type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
              payload: DATA_LOAD_STATUS.error,
            });
            //ON_IFS_DOCUMENT_LOAD_CHANGED
            dispatch({
              type: ON_IFS_DOCUMENT_LOAD_CHANGED,
              payload: DATA_LOAD_STATUS.onLoad,
            });
            dispatch({
              type: ON_IFS_DOCUMENTS_SELECTED,
              payload: [],
            });
            let serverResponseError = {
              response: error.response,
              statusCode: error.response.status,
              error: error.toJSON(),
            };
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });

            dispatch({
              type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
          }
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: true,
      };

      dispatch({
        type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      dispatch({
        type: ON_IFS_DOCUMENT_LOAD_CHANGED,
        payload: DATA_LOAD_STATUS.partialCompleted,
      });
      dispatch({
        type: ON_IFS_DOCUMENTS_SELECTED,
        payload: [],
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_CHECKOUT_DOCUMENT_STATUS_CHANGE,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
    }
  };

export const onIfsPreviewDocument =
  (tanentId, selectedIfsDocument, fileRoot) => async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    dispatch({
      type: ON_SPINNER_TEXT_CHANGE,
      payload: PREVIEW_URL_EMPTY,
    });
    dispatch({
      type: ON_DOCUMENT_DOWNLOAD,
      payload: true,
    });

    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onIfsPreviewDocument",
      statusCode: 0,
    };
    try {
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      const ifsPreviewDocument = [];
      for (let item of selectedIfsDocument) {
        ifsPreviewDocument.push({
          docClass: getDocClassCodeOnly(item.class ?? item.docClass ?? ""),
          docNo: item.docNo,
          docSheet: item.sheetNo,
          docRev: item.docRev,
          docType: item.docType,
          fileNo: item.fileNo,
          Title: item.title,
          fileExtension: item.fileExtension,
        });
      }
      let teamId = "";
      let channelId = "";
      await authAxio
        .post(
          "/api/Document/upload-to-onedrive?userId=" +
            new AuthTeams().getUserId() +
            "&tenantId=" +
            tanentId +
            "&teamId=" +
            teamId +
            "&channelId=" +
            channelId +
            "&oneDriveRoot=" +
            fileRoot +
            "&webUser=" +
            new AuthTeams().getEmail(),
          ifsPreviewDocument,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          let messageBox = {
            type: ERROR_TYPE,
            message: IFS_SERVER_ERROR,
            errorMessage: "",
            error: null,
          };
          switch (res.status) {
            case 200:
              dispatch({
                type: ONEDRIVE_DOCUMENT_ID,
                payload: res.data[0].value.id,
              });
              break;
            case 201:
            case 204:
            default:
              messageBox.message = `${PREVIEW_NOT_FOUND}`;
              appInsights.trackException({
                error: `${PREVIEW_NOT_FOUND}`,
                appInsightProps,
              });

              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                payload: DATA_LOAD_STATUS.noDate,
              });
              dispatch({
                type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.partialCompleted,
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
              break;
            case 202:
              messageBox.message = `${IFS_SERVER_ERROR}`;
              messageBox.errorMessage = res.data !== null ? `${res.data}` : "";
              appInsights.trackException({
                error:
                  messageBox.errorMessage === ""
                    ? messageBox.errorMessage
                    : `${IFS_SERVER_ERROR}`,
                appInsightProps,
              });

              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
                payload: DATA_LOAD_STATUS.error,
              });
              dispatch({
                type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.partialCompleted,
              });
              dispatch({
                type: ON_IFS_DOCUMENTS_SELECTED,
                payload: [],
              });
              dispatch({
                type: ON_DOCUMENT_DOWNLOAD,
                payload: false,
              });
              dispatch({
                type: ON_SPINNER_TEXT_CHANGE,
                payload: "",
              });
              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          appInsightProps.statusCode =
            error.response === undefined ? 0 : error.response.status;
          appInsights.trackException({
            error: error.toJSON(),
            appInsightProps,
          });
          let messageBox = {
            type: ERROR_TYPE,
            message: FAILED_PREVIEW_DOC,
            errorMessage: "",
            error: error.toJSON(),
          };
          if (error.response) {
            messageBox.errorMessage = error.response.data
              ? error.response.data
              : `${error.response.message}`;
          } else if (error.request) {
            messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
          } else {
            messageBox.errorMessage =
              error !== null
                ? `${ERROR_DETAILS} ${error.toJSON().message}`
                : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
          }
          dispatch({
            type: ON_MESSAGE_BOX_INVOKE,
            payload: messageBox,
          });
          dispatch({
            type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
            payload: DATA_LOAD_STATUS.error,
          });
          dispatch({
            type: ON_IFS_DOCUMENT_LOAD_CHANGED,
            payload: DATA_LOAD_STATUS.partialCompleted,
          });
          dispatch({
            type: ON_MESSAGE_BOX_OPEN,
            payload: true,
          });
          dispatch({
            type: ON_IFS_DOCUMENTS_SELECTED,
            payload: [],
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: false,
          });
          dispatch({
            type: ON_SPINNER_TEXT_CHANGE,
            payload: "",
          });
        });
    } catch (ex) {
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_TO_CREATE_PDF,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      dispatch({
        type: ON_IFS_DOCUMENT_LOAD_CHANGED,
        payload: DATA_LOAD_STATUS.partialCompleted,
      });
      dispatch({
        type: ON_IFS_DOCUMENTS_SELECTED,
        payload: [],
      });
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      dispatch({
        type: ON_SPINNER_TEXT_CHANGE,
        payload: "",
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
    }
  };

export const onWorkingDocumentLoad =
  (
    teamId,
    channelId,
    tenantId,
    fileRoot,
    displayCount,
    tokenRefreshPreAction,
  ) =>
  async (dispatch) => {
    dispatch({
      type: ON_WORKING_DOCUMENT_LIST,
      payload: [],
    });
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    if (isTokenRefreshFailed(tokenRefreshPreAction)) {
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: {
          retry: 0,
          actionType: REFRESH_TOKEN_ACTION.none,
        },
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      let messageBox = {
        type: ERROR_TYPE,
        message: IFS_TOKEN_EXPIRED,
      };
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: messageBox,
      });

      dispatch({
        type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });

      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });

      dispatch({
        type: ON_WORKING_DOCUMENT_LIST,
        payload: [],
      });
      return;
    }

    dispatch({
      type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
      payload: DOCUMENT_LOAD_STATUS.onLoading,
    });
    dispatch({
      type: ON_WORKING_DOCUMENT_LIST,
      payload: [],
    });
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onWorkingDocumentLoad",
      channelId: channelId,
      teamId: teamId,
      tenantId: tenantId,
      fileRoot: fileRoot,
    };
    let messageBox = {
      type: ERROR_TYPE,
      message: SERVER_RESPONSE_ERROR,
      errorMessage: "",
      error: null,
    };
    try {
      const config = new CustomerConfig();
      const authAxio = axios.create({
        baseURL: config.getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      let recFrom = 0;
      let recSize = config.getDataLimit(config.get_OneDriveDataString());
      let fileType = "''";
      let searchText = "";
      let filters = {
        userId: new AuthTeams().getUserId(),
        tenantId: tenantId,
        fileType: fileType,
        searchText: searchText,
        recFrom: recFrom,
        recSize: recSize,
        teamId: teamId,
        channelId: channelId,
        clientId: new AuthTeams().getClientId(),
        oneDriveRoot: fileRoot,
        isOnedrive: false,
        displayCount: displayCount,
      };
      let filterString = JSON.stringify(filters);
      await authAxio
        .get(
          config.getServiceApi() +
            "api/OneDrive/get-working-documents?filter=" +
            filterString,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "E-Tag": config.getOneDriveETag(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 200:
              let data = [];
              if (res !== null && res.data !== "" && res.data.value !== null) {
                data = res.data.value;
              }
              dispatch({
                type: ON_WORKING_DOCUMENT_LIST,
                payload: data,
              });
              dispatch({
                type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.onCompletion,
              });
              break;
            case 204:
              dispatch({
                type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.noData,
              });
              dispatch({
                type: ON_WORKING_DOCUMENT_LIST,
                payload: [],
              });
              break;
            default:
              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
                showMessageBox: false,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              dispatch({
                type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
              dispatch({
                type: ON_WORKING_DOCUMENT_LIST,
                payload: [],
              });
              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");

          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.workingDocumentsLoad,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                tokenRefreshPreAction,
                REFRESH_TOKEN_ACTION.workingDocumentsLoad,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          } else {
            let serverResponseError = {
              response: error.response,
              statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
              error: error,
              showMessageBox: false,
            };

            dispatch({
              type: ON_WORKING_DOCUMENT_LIST,
              payload: [],
            });
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });
            dispatch({
              type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
          }
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: false,
      };
      dispatch({
        type: ON_WORKING_DOCUMENT_LIST,
        payload: [],
      });
      dispatch({
        type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
    }
  };

export const onOneDriveDocument =
  (
    teamId,
    channelId,
    tenantId,
    pageSize,
    searchText,
    documentType,
    fileRoot,
    isOnedrive,
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }
    try {
      const config = new CustomerConfig();
      const authAxio = axios.create({
        baseURL: config.getServiceApi(),
      });
      dispatch({
        type: ON_PAGE_SIZE_CHANGE,
        payload: pageSize,
      });
      dispatch({
        type: ON_SELECTED_PAGE_INDEX_CHANGE,
        payload: DEFAULT_SELECTED_PAGE_INDEX,
      });
      dispatch({
        type: ON_PAGE_SIZE_CHANGE,
        payload: pageSize,
      });
      dispatch({
        type: ON_SEARCH,
        payload: searchText,
      });
      config.setOneDriveETag(getETag());
      dispatch({
        type: ONEDRIVE_SEARCH_Filtered,
        payload: null,
      });
      dispatch({
        type: ON_ONEDRIVE_SEARCH_BACKEND,
        payload: [],
      });
      dispatch({
        type: ONEDRIVE_SEARCH,
        payload: [],
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      let fileType = documentType;
      let recFrom = 0;
      let recSize = config.getDataLimit(config.get_OneDriveDataString());
      recFrom = 0;
      recSize = config.getPageLimit();

      await authAxio
        .get(
          config.getServiceApi() +
            "api/OneDrive/get-onedrive-docs?userId=" +
            new AuthTeams().getUserId() +
            "&tenantId=" +
            tenantId +
            "&fileType=" +
            fileType +
            "&searchText=" +
            searchText +
            "&recFrom=" +
            recFrom +
            "&recSize=" +
            recSize +
            "&teamId=" +
            teamId +
            "&channelId=" +
            channelId +
            "&clientId=" +
            new AuthTeams().getClientId() +
            "&oneDriveRoot=" +
            fileRoot +
            "&isOnedrive=" +
            isOnedrive,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "E-Tag": config.getOneDriveETag(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 200:
              let updateRecords = true;
              /* Check if the eTag is same as the previous one */
              if (res.data !== null || res.data !== "") {
                if (res.data.eTag) {
                  if (res.data.eTag !== config.getOneDriveETag()) {
                    updateRecords = false;
                  }
                }
              }
              if (updateRecords) {
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_BACKEND,
                  payload: res.data,
                });
                dispatch({
                  type: ONEDRIVE_SEARCH,
                  payload: res.data,
                });
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
                  payload: res.data,
                });
                if (
                  res !== null &&
                  res.data !== "" &&
                  res.data.value !== null
                ) {
                  res.data.value = res.data.value.slice(0, pageSize);
                }
                dispatch({
                  type: ONEDRIVE_SEARCH_Filtered,
                  payload: res.data,
                });
              }
              dispatch({
                type: ON_ONEDRIVE_DATALOAD,
                payload: DATA_LOAD_STATUS.completed,
              });
              dispatch({
                type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
              dispatch({
                type: ON_PAGINATION_LOAD,
                payload: DATA_LOAD_STATUS.onLoad,
              });
              dispatch({
                type: ON_ONEDRIVE_DATALOAD,
                payload: DATA_LOAD_STATUS.completed,
              });
              break;
            case 204:
              dispatch({
                type: ON_ONEDRIVE_SEARCH_BACKEND,
                payload: "",
              });
              dispatch({
                type: ONEDRIVE_SEARCH,
                payload: "",
              });
              dispatch({
                type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
                payload: "",
              });
              dispatch({
                type: ONEDRIVE_SEARCH_Filtered,
                payload: "",
              });
              dispatch({
                type: ON_ONEDRIVE_DATALOAD,
                payload: DATA_LOAD_STATUS.noDate,
              });
              break;
            default:
              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              dispatch({
                type: ON_ONEDRIVE_SEARCH_BACKEND,
                payload: "",
              });
              dispatch({
                type: ONEDRIVE_SEARCH,
                payload: "",
              });
              dispatch({
                type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
                payload: "",
              });
              dispatch({
                type: ONEDRIVE_SEARCH_Filtered,
                payload: "",
              });
              dispatch({
                type: ON_ONEDRIVE_DATALOAD,
                payload: DATA_LOAD_STATUS.error,
              });
              break;
          }
        })
        .catch(function (error) {
          let serverResponseError = {
            response: error.response,
            statusCode: error.response.status,
            error: error.toJSON(),
          };
          dispatch({
            type: ON_SERVER_ERROR_MESSAGE_INVOKE,
            payload: serverResponseError,
          });
          dispatch({
            type: ON_ONEDRIVE_SEARCH_BACKEND,
            payload: "",
          });
          dispatch({
            type: ONEDRIVE_SEARCH,
            payload: "",
          });
          dispatch({
            type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
            payload: "",
          });
          dispatch({
            type: ONEDRIVE_SEARCH_Filtered,
            payload: "",
          });
          dispatch({
            type: ON_ONEDRIVE_DATALOAD,
            payload: DATA_LOAD_STATUS.error,
          });
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: true,
      };
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_ONEDRIVE_SEARCH_BACKEND,
        payload: "",
      });
      dispatch({
        type: ONEDRIVE_SEARCH,
        payload: "",
      });
      dispatch({
        type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
        payload: "",
      });
      dispatch({
        type: ONEDRIVE_SEARCH_Filtered,
        payload: "",
      });
      dispatch({
        type: ON_ONEDRIVE_DATALOAD,
        payload: DATA_LOAD_STATUS.error,
      });
    }
  };

export const onDeleteOneDriveDocument =
  (
    membershipType,
    fileId,
    teamId,
    document,
    operationType = DOC_CHECK_IN_TYPE.checkinNewRevision,
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    try {
      const config = new CustomerConfig();
      const authAxio = axios.create({
        baseURL: config.getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      await authAxio
        .get(
          config.getServiceApi() +
            "api/OneDrive/del-onedrive-docs?userId=" +
            new AuthTeams().getUserId() +
            "&membershipType=" +
            membershipType +
            "&teamId=" +
            teamId +
            "&fileId=" +
            fileId,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "E-Tag": config.getOneDriveETag(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 204:
            case 200:
              console.log("OneDrive doc deleted.");
              switch (operationType) {
                case DOC_CHECK_IN_TYPE.checkinExisting:
                case DOC_CHECK_IN_TYPE.deleteExisting:
                  dispatch({
                    type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                  break;
                case DOC_CHECK_IN_TYPE.checkinNewRevision:
                  dispatch({
                    type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                  break;
                case DOC_CHECK_IN_TYPE.checkinNew:
                  dispatch({
                    type: ON_CHECKIN_DOCUMENT_PROGRESS,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                  break;
                default:
                  dispatch({
                    type: ON_CHECKIN_DOCUMENT_PROGRESS,
                    payload: DATA_LOAD_STATUS.onStart,
                  });
                  break;
              }
              dispatch({
                type: ON_DELETE_ONEDRIVE_SUCCESS,
                payload: { fileId, document, operationType },
              });
              break;
            default:
              // dispatch({
              //   type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
              //   payload: DOCUMENT_LOAD_STATUS.onError,
              // });

              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
                domain: DELETE_FILE,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              switch (operationType) {
                case DOC_CHECK_IN_TYPE.checkinExisting:
                  dispatch({
                    type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                  break;
                case DOC_CHECK_IN_TYPE.deleteExisting:
                  dispatch({
                    type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onError,
                  });
                  break;
                case DOC_CHECK_IN_TYPE.checkinNewRevision:
                  dispatch({
                    type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                  break;
                case DOC_CHECK_IN_TYPE.checkinNew:
                  dispatch({
                    type: ON_CHECKIN_DOCUMENT_PROGRESS,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                  break;
                default:
                  dispatch({
                    type: ON_CHECKIN_DOCUMENT_PROGRESS,
                    payload: DATA_LOAD_STATUS.error,
                  });
                  break;
              }

              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (userAuth.isIfsUserLoginRequired(error.response)) {
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          }
          if (error.response.status === 423) {
            let messageBox = {
              type: ERROR_TYPE,
              message: ONEDRIVE_DOCUMENT_LOCKED_ERROR,
              domain: DELETE_FILE,
            };

            dispatch({
              type: ON_ERROR_MESSAGE_INVOKE,
              payload: messageBox,
            });
          } else {
            let serverResponseError = {
              response: error.response,
              statusCode: error.response.status,
              error: error.toJSON(),
              domain: DELETE_FILE,
            };
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });
            dispatch({
              type: ON_DELETE_ONEDRIVE_ERROR,
              payload: {
                error: error,
                document: document,
                operationType: operationType,
              },
            });
          }
          dispatch({
            type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
            payload: DOCUMENT_LOAD_STATUS.onLoad,
          });
          switch (operationType) {
            case DOC_CHECK_IN_TYPE.checkinExisting:
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onCompletion,
              });
              break;
            case DOC_CHECK_IN_TYPE.deleteExisting:
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
              break;
            case DOC_CHECK_IN_TYPE.checkinNewRevision:
              dispatch({
                type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onCompletion,
              });
              break;
            case DOC_CHECK_IN_TYPE.checkinNew:
              dispatch({
                type: ON_CHECKIN_DOCUMENT_PROGRESS,
                payload: DOCUMENT_LOAD_STATUS.onCompletion,
              });
              break;
            default:
              dispatch({
                type: ON_CHECKIN_DOCUMENT_PROGRESS,
                payload: DATA_LOAD_STATUS.error,
              });
              break;
          }
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: true,
        domain: DELETE_FILE,
      };

      dispatch({
        type: ON_WORKING_DOCUMENT_LIST_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      switch (operationType) {
        case DOC_CHECK_IN_TYPE.checkinExisting:
          dispatch({
            type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        case DOC_CHECK_IN_TYPE.deleteExisting:
          dispatch({
            type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onError,
          });
          break;
        case DOC_CHECK_IN_TYPE.checkinNewRevision:
          dispatch({
            type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        case DOC_CHECK_IN_TYPE.checkinNew:
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        default:
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DATA_LOAD_STATUS.error,
          });
          break;
      }
    }
  };

/***************** Obsolete method use onDeleteOneDriveDocument instead *******************/
export const onDelOneDriveDocument = (fileId, teamId) => async (dispatch) => {
  const tokenResponse = await userAuth.getUserToken(true);
  const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
  if (!tokenOneDrive) {
    dispatch({
      type: ON_TOKEN_FAIL,
      payload: tokenResponse,
    });
    return;
  }
  let appInsightProps = {
    userId: new AuthTeams().getEmail(),
    functionName: "onDelOneDriveDocument",
    teamId: teamId,
    fileId: fileId,
  };
  try {
    const config = new CustomerConfig();
    const authAxio = axios.create({
      baseURL: config.getServiceApi(),
    });

    authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

    await authAxio
      .get(
        config.getServiceApi() +
          "api/OneDrive/del-onedrive-docs?userId=" +
          new AuthTeams().getUserId() +
          "&teamId=" +
          teamId +
          "&fileId=" +
          fileId,
        {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Customer-Key": new AuthTeams().getCustomerKey(),
            "E-Tag": config.getOneDriveETag(),
            "User-Key": new AuthTeams().getUserKey(),
          },
        },
      )
      .then((res) => {
        switch (res.status) {
          case 204:
            console.log("OneDrive doc deleted.");
            dispatch({
              type: ON_DELETE_SUCCESS,
              payload: true,
            });
            break;
          default:
            let messageBox = {
              type: ERROR_TYPE,
              message: SERVER_RESPONSE_ERROR,
              errorMessage: "",
              error: null,
            };

            if (res.data) {
              messageBox.errorMessage = `${res.data}`;
              console.log(res.data, "err");
              appInsightProps.statusCode = res.status;
              appInsights.trackException({
                error: res.data,
                appInsightProps,
              });
            } else {
              messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
            }
            break;
        }
      })
      .catch(function (error) {
        console.log(error.toJSON(), "err");
        appInsightProps.statusCode =
          error.response === undefined ? 0 : error.response.status;
        appInsights.trackException({
          error: error.toJSON(),
          appInsightProps,
        });
        let messageBox = {
          type: ERROR_TYPE,
          message: SEARCH_RESULT_FAILED,
          errorMessage: "",
          error: error.toJSON(),
        };
        if (error.response.data) {
          messageBox.errorMessage =
            error.response.status === 400
              ? `${error.response.data}`
              : `${error.toJSON().message}`;
        } else if (error.request.response) {
          messageBox.errorMessage = `${error.request.response}`;
        } else {
          messageBox.errorMessage =
            error !== null
              ? `${ERROR_DETAILS} ${error.toJSON().message}`
              : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
        }
      });
  } catch (ex) {
    console.log(ex.message, "err");
    appInsightProps.statusCode = 0;
    appInsights.trackException({ error: ex.message, appInsightProps });
  }
};


export const onOpenInIFS =
  (items, docType, linkPlatform, aurenaShowDetails) => async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onOpenInIFS",
      statusCode: 0,
      items: items,
      docType: docType,
      linkPlatform: linkPlatform,
      aurenaShowDetails: aurenaShowDetails,
    };
    let url = "";
    try {
      dispatch({
        type: ON_GENERATING_COPY_LINKS,
        payload: { text: "Generating URLs...", state: true },
      });
      appInsights.trackTrace({
        message: "Sharing Document Url Requested",
        appInsightProps,
      });

      const tokenResponse = await userAuth.getUserToken(true);
      const tokenTeams = tokenResponse ? tokenResponse.accessToken : null;

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenTeams}`;

      const documentInfoList = [];
      documentInfoList.push({
        OneDriveDocId: items.id,
        OneDriveItemId: items.ItemsId,
        OneDriveDriveId: items.DriveId,
        DocClass: getValidValue(items.DocClass, ""),
        DocNo: getValidValue(items.DocNo, ""),
        DocSheet: getValidValue(items.DocSheet, ""),
        DocRev: getValidValue(items.DocRev, ""),
        Title: items.name,
        ApplicationType: linkPlatform,
        DocType: docType,
        FileNo: 1,
        AurenaShowDetails: aurenaShowDetails,
      });

      const response = await authAxio
        .post(
          "api/Document/get-ifs-document-url?webUser=" + new AuthTeams().getEmail(),
          documentInfoList,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          let warningMessage = {
            type: WARNING_TYPE,
            message: IFS_DOCUMENT_NO_DATA,
            errorMessage: "",
            error: null,
          };
          switch (res.status) {
            case 200:
              if (res.data !== null && res.data.length > 0) {
                url = res.data[0];
                if (
                  url === null ||
                  url === "" ||
                  url === "Error" ||
                  url === "Invalid"
                ) {
                  dispatch({
                    type: ON_WARNING_MESSAGE_INVOKE,
                    payload: warningMessage,
                  });
                  dispatch({
                    type: ON_VIWE_DOCUMENT_WEB,
                    payload: { text: "", state: false },
                  });
                  url = "";
                }
              } else {
                dispatch({
                  type: ON_WARNING_MESSAGE_INVOKE,
                  payload: warningMessage,
                });
              }
              dispatch({
                type: ON_VIWE_DOCUMENT_WEB,
                payload: { text: "", state: false },
              });
              return url;
            case 204:
              dispatch({
                type: ON_WARNING_MESSAGE_INVOKE,
                payload: warningMessage,
              });
              dispatch({
                type: ON_VIWE_DOCUMENT_WEB,
                payload: { text: "", state: false },
              });
              break;
            default:
              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
                showMessageBox: true,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
              dispatch({
                type: ON_VIWE_DOCUMENT_WEB,
                payload: { text: "", state: false },
              });
              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          let serverResponseError = {
            response: error.response,
            statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
            error: error,
            showMessageBox: true,
          };

          if (userAuth.isIfsUserLoginRequired(error.response)) {
            //Trigger IFS User Login
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          }
          dispatch({
            type: ON_VIWE_DOCUMENT_WEB,
            payload: { text: "", state: false },
          });
          dispatch({
            type: ON_SERVER_ERROR_MESSAGE_INVOKE,
            payload: serverResponseError,
          });
        });
      return url;
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: false,
      };
      dispatch({
        type: ON_VIWE_DOCUMENT_WEB,
        payload: { text: "", state: false },
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      return url;
    }
  };

/** Thin wrapper: dispatches getDocumentUrl (RTK slice) and returns { data } for legacy callers. */
export const onCopyLinkCopyClick =
  (items, docType, linkPlatform, aurenaShowDetails) => async (dispatch) => {
    const result = await dispatch(
      getDocumentUrl({ items, docType, linkPlatform, aurenaShowDetails })
    );
    if (getDocumentUrl.fulfilled.match(result) && result.payload != null) {
      return { data: result.payload };
    }
    return undefined;
  };

export const onOneDriveDocumentObsolete =
  (
    teamId,
    channelId,
    tenantId,
    pageSize,
    searchText,
    documentType,
    isBackgroundLoad,
    fileRoot,
    isOnedrive,
  ) =>
  async (dispatch) => {
    if (isBackgroundLoad) {
      dispatch({
        type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
        payload: DATA_LOAD_STATUS.inProgress,
      });
    }
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onOneDriveDocumenta",
      channelId: channelId,
      teamId: teamId,
      tenantId: tenantId,
      pageSize: pageSize,
      searchText: searchText,
      documentType: documentType,
    };
    try {
      const config = new CustomerConfig();
      const authAxio = axios.create({
        baseURL: config.getServiceApi(),
      });
      // dispatch({
      //   type: SET_INITIAL_VALUE,
      //   payload: [],
      // });
      dispatch({
        type: ON_PAGE_SIZE_CHANGE,
        payload: pageSize,
      });
      dispatch({
        type: ON_SELECTED_PAGE_INDEX_CHANGE,
        payload: DEFAULT_SELECTED_PAGE_INDEX,
      });
      dispatch({
        type: ON_PAGE_SIZE_CHANGE,
        payload: pageSize,
      });
      dispatch({
        type: ON_SEARCH,
        payload: searchText,
      });
      if (!isBackgroundLoad) {
        config.setOneDriveETag(getETag());
        dispatch({
          type: ONEDRIVE_SEARCH_Filtered,
          payload: null,
        });
        dispatch({
          type: ON_ONEDRIVE_SEARCH_BACKEND,
          payload: [],
        });
        dispatch({
          type: ONEDRIVE_SEARCH,
          payload: [],
        });
      }
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      let fileType = documentType;
      let recFrom = 0;
      let recSize = config.getDataLimit(config.get_OneDriveDataString());
      if (!isBackgroundLoad) {
        recFrom = 0;
        recSize = config.getPageLimit();
      }

      await authAxio
        .get(
          config.getServiceApi() +
            "api/OneDrive/get-onedrive-docs?userId=" +
            new AuthTeams().getUserId() +
            "&tenantId=" +
            tenantId +
            "&fileType=" +
            fileType +
            "&searchText=" +
            searchText +
            "&recFrom=" +
            recFrom +
            "&recSize=" +
            recSize +
            "&teamId=" +
            teamId +
            "&channelId=" +
            channelId +
            "&clientId=" +
            new AuthTeams().getClientId() +
            "&oneDriveRoot=" +
            fileRoot +
            "&isOnedrive=" +
            isOnedrive,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "E-Tag": config.getOneDriveETag(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 200:
              if (isBackgroundLoad) {
                let updateRecords = true;
                /* Check if the eTag is same as the previous one */
                if (res.data !== null || res.data !== "") {
                  if (res.data.eTag) {
                    if (res.data.eTag !== config.getOneDriveETag()) {
                      updateRecords = false;
                    }
                  }
                }
                if (updateRecords) {
                  dispatch({
                    type: ON_ONEDRIVE_SEARCH_BACKEND,
                    payload: res.data,
                  });
                  dispatch({
                    type: ONEDRIVE_SEARCH,
                    payload: res.data,
                  });
                  dispatch({
                    type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
                    payload: res.data,
                  });
                  if (
                    res !== null &&
                    res.data !== "" &&
                    res.data.value !== null
                  ) {
                    res.data.value = res.data.value.slice(0, pageSize);
                  }
                  dispatch({
                    type: ONEDRIVE_SEARCH_Filtered,
                    payload: res.data,
                  });
                }
                dispatch({
                  type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.completed,
                });
                dispatch({
                  type: ON_PAGINATION_LOAD,
                  payload: DATA_LOAD_STATUS.onLoad,
                });
              } else {
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_BACKEND,
                  payload: res.data,
                });
                dispatch({
                  type: ONEDRIVE_SEARCH,
                  payload: res.data,
                });
                if (
                  res !== null &&
                  res.data !== "" &&
                  res.data.value !== null
                ) {
                  res.data.value = res.data.value.slice(0, pageSize);
                }
                dispatch({
                  type: ONEDRIVE_SEARCH_Filtered,
                  payload: res.data,
                });
                dispatch({
                  type: ON_ONEDRIVE_DATALOAD,
                  payload: DATA_LOAD_STATUS.completed,
                });
                dispatch({
                  type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.onLoad,
                });
              }
              break;
            case 202:
              if (isBackgroundLoad) {
                dispatch({
                  type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.oneDriveError,
                });
              } else {
                let messageBox = {
                  type: ERROR_TYPE,
                  message: IFS_DOCUMENT_LOAD_ERROR,
                  errorMessage: "",
                  error: null,
                };
                dispatch({
                  type: ON_IFS_DOCUMENT_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.completed,
                });
                dispatch({
                  type: ON_DISPLAY_DETAILS_BUTTON,
                  payload: false,
                });

                if (res.data) {
                  messageBox.errorMessage = `${res.data}`;
                  console.log(res.data, "err");
                  appInsightProps.statusCode = res.status;
                  appInsights.trackException({
                    error: res.data,
                    appInsightProps,
                  });
                } else {
                  messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
                }

                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: messageBox,
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_BACKEND,
                  payload: "",
                });
                dispatch({
                  type: ONEDRIVE_SEARCH,
                  payload: "",
                });
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
                  payload: "",
                });
                dispatch({
                  type: ONEDRIVE_SEARCH_Filtered,
                  payload: "",
                });
                dispatch({
                  type: ON_ONEDRIVE_DATALOAD,
                  payload: DATA_LOAD_STATUS.error,
                });
              }
              break;
            case 204:
            default:
              if (isBackgroundLoad) {
                dispatch({
                  type: ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
                  payload: DATA_LOAD_STATUS.completed,
                });
              } else {
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_BACKEND,
                  payload: "",
                });
                dispatch({
                  type: ONEDRIVE_SEARCH,
                  payload: "",
                });
                dispatch({
                  type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
                  payload: "",
                });
                dispatch({
                  type: ONEDRIVE_SEARCH_Filtered,
                  payload: "",
                });
                dispatch({
                  type: ON_ONEDRIVE_DATALOAD,
                  payload: DATA_LOAD_STATUS.noDate,
                });
              }
              break;
          }
        })
        .catch(function (error) {
          if (isBackgroundLoad) {
            dispatch({
              type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
              payload: DATA_LOAD_STATUS.error,
            });
          } else {
            console.log(error.toJSON(), "err");
            appInsightProps.statusCode =
              error.response === undefined ? 0 : error.response.status;
            appInsights.trackException({
              error: error.toJSON(),
              appInsightProps,
            });
            let messageBox = {
              type: ERROR_TYPE,
              message: SEARCH_RESULT_FAILED,
              errorMessage: "",
              error: error.toJSON(),
            };
            if (error.response.data) {
              messageBox.errorMessage =
                error.response.status === 400
                  ? `${error.response.data}`
                  : `${error.toJSON().message}`;
            } else if (error.request.response) {
              messageBox.errorMessage = `${error.request.response}`;
            } else {
              messageBox.errorMessage =
                error !== null
                  ? `${ERROR_DETAILS} ${error.toJSON().message}`
                  : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
            }
            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_ONEDRIVE_SEARCH_BACKEND,
              payload: "",
            });
            dispatch({
              type: ONEDRIVE_SEARCH,
              payload: "",
            });
            dispatch({
              type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
              payload: "",
            });
            dispatch({
              type: ONEDRIVE_SEARCH_Filtered,
              payload: "",
            });
            dispatch({
              type: ON_ONEDRIVE_DATALOAD,
              payload: DATA_LOAD_STATUS.error,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
          }
        });
    } catch (ex) {
      if (isBackgroundLoad) {
        dispatch({
          type: ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
      } else {
        dispatch({
          type: ON_ONEDRIVE_SEARCH_BACKEND,
          payload: "",
        });
        dispatch({
          type: ONEDRIVE_SEARCH,
          payload: "",
        });
        dispatch({
          type: ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE,
          payload: "",
        });
        dispatch({
          type: ONEDRIVE_SEARCH_Filtered,
          payload: "",
        });
        dispatch({
          type: ON_ONEDRIVE_DATALOAD,
          payload: DATA_LOAD_STATUS.error,
        });

        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: {
            type: ERROR_TYPE,
            message: SEARCH_RESULT_FAILED,
            errorMessage: ex.message,
            error: null,
          },
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
        dispatch({
          type: ON_ONEDRIVE_DATALOAD,
          payload: DATA_LOAD_STATUS.error,
        });
        console.log(ex.message, "err");
        appInsightProps.statusCode = 0;
        appInsights.trackException({ error: ex.message, appInsightProps });
      }
    }
  };
